webpackJsonp([1],{

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
    install: function install(Vue) {
        Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+MYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.data)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Календарь публикаций")]),_vm._v(" "),_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n            Закрыть\n        ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+YzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: {
                status: 0,
                tracks_number: 0,
                translations: [],
                image_src: null,
                image_src_full: null,
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/albums/create', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/albums');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album.image_src = data.url;
                self.album.image_src_full = data.url_full;
                self.album.image_src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "+cI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+iwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("Pfth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1d82f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("hszI");
function injectStyle (ssrContext) {
  __webpack_require__("CMwh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a1d82f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1d82f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/8N7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("pEA8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f06bb23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Xwwm");
function injectStyle (ssrContext) {
  __webpack_require__("V19S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f06bb23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f06bb23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Bd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n                © 2017, made with\n                "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Z3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/p5S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "06e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'is_premium', 'push_type', 'videos', 'duration', 'sort', 'status', ''],
            data: [],
            role: parseInt(localStorage.getItem('role')) || 0,
            categoryId: localStorage.getItem('ctt_category') ? localStorage.getItem('ctt_category') : "",
            status: localStorage.getItem('ctt_status') ? localStorage.getItem('ctt_status') : "",
            isTrendy: localStorage.getItem('ctt_is_trendy') ? localStorage.getItem('ctt_is_trendy') : "",
            isCopyrighted: localStorage.getItem('ctt_is_copyrighted') ? localStorage.getItem('ctt_is_copyrighted') : "",
            isNew: localStorage.getItem('ctt_is_new') ? localStorage.getItem('ctt_is_new') : "",
            categories: [],
            filteredId: null,
            limit: 10,
            offset: parseInt(localStorage.getItem('ctt_active_offset')) || 0
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        },
        toShortText: function toShortText(value) {
            if (value) {
                return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10);
            } else {
                return '';
            }
        }
    },
    methods: {
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        isWrongDuration: function isWrongDuration(template) {

            var sum = 0;
            _.map(template.parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return parseFloat(sum.toFixed(2)) !== template.duration;
        },
        add: function add() {
            this.$router.push('/memories/create');
        },
        filter: function filter() {
            localStorage.setItem('ctt_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        edit: function edit(id) {
            if (this.role > 1) {
                return false;
            }
            //localStorage.setItem('w_last_opened_id', parseInt(id));
            this.$router.push({
                name: 'edit-for-you',
                params: { id: id }
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var status = this.status === null ? '' : this.status;
            var isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
            var isNew = this.isNew === null ? '' : this.isNew;
            var filteredId = this.filteredId === null ? '' : this.filteredId;

            axios.get(this.$hostname + '/admin/created', {
                'params': {
                    status: status,
                    isCopyrighted: isCopyrighted,
                    isNew: isNew,
                    limit: self.limit,
                    offset: self.offset,
                    filteredId: filteredId
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;

                self.data = data.templates;
            }).catch(function (error) {
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('ctt_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('ctt_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('templates') < 1) {
            localStorage.setItem('ctt_active_offset', "0");
            localStorage.setItem('ctt_category', "");
            localStorage.setItem('ctt_status', "");
            localStorage.setItem('ctt_is_trendy', "");
            localStorage.setItem('ctt_is_copyrighted', "");
        }
        next();
    }
});

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("G0RX");
function injectStyle (ssrContext) {
  __webpack_require__("7707")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
    install: function install(Vue) {
        Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
        Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
        Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
    }
});

/***/ }),

/***/ "2R7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__("EZIe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d503d5ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__("wD3J");
function injectStyle (ssrContext) {
  __webpack_require__("8l6I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d503d5ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d503d5ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("U6AA");
function injectStyle (ssrContext) {
  __webpack_require__("DomV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77256d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2zcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"/templates"}},[_vm._m(0),_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",function(){return _vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(".nav-link\n                    "),_c('p',[_vm._v(_vm._s(link.name))])])})})],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3C/Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    inject: {
        autoClose: {
            default: true
        }
    },
    props: {
        link: {
            type: [String, Object],
            default: function _default() {
                return {
                    name: '',
                    path: '',
                    icon: ''
                };
            }
        },
        tag: {
            type: String,
            default: 'router-link'
        }
    },
    methods: {
        hideSidebar: function hideSidebar() {
            if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
});

/***/ }),

/***/ "4SD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            is_object_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            active_object_category: 'arrows',
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                shadow_blur: 0,
                shadow_alpha: 0,
                animation_type: 0,
                animation_duration: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0
            },
            texts: [],
            objects: [],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }, {
                params: "'Amsterdam Four', sans-serif;",
                code: "Amsterdam Four",
                name: "Amsterdam Four"
            }, {
                params: "'Bodoni 72', sans-serif;",
                code: "Bodoni 72",
                name: "Bodoni 72"
            }, {
                params: "'Courier New', sans-serif;",
                code: "Courier New",
                name: "Courier New"
            }, {
                params: "'Didot', sans-serif;",
                code: "Didot",
                name: "Didot"
            }, {
                params: "'Menlo', sans-serif;",
                code: "Menlo",
                name: "Menlo"
            }, {
                params: "'Optima', sans-serif;",
                code: "Optima",
                name: "Optima"
            }, {
                params: "'Copperplate Gothic Light', sans-serif;",
                code: "Copperplate Gothic Light",
                name: "Copperplate"
            }, {
                params: "'Avenir', sans-serif;",
                code: "Avenir",
                name: "Avenir"
            }, {
                params: "'AmaticSC-Bold', sans-serif;",
                code: "AmaticSC-Bold",
                name: "Amatic SC"
            }, {
                params: "'Zapfino', sans-serif;",
                code: "Zapfino",
                name: "Zapfino"
            }, {
                params: "'BebasNeue-Regular', sans-serif;",
                code: "BebasNeue-Regular",
                name: "Bebas Neue"
            }, {
                params: "'Noteworthy', sans-serif;",
                code: "Noteworthy",
                name: "Noteworthy"
            }, {
                params: "'DancingScript-Bold', sans-serif;",
                code: "DancingScript-Bold",
                name: "Dancing Script"
            }, {
                params: "'Chilanka-Regular', sans-serif;",
                code: "Chilanka-Regular",
                name: "Chilanka"
            }, {
                params: "'Intro', sans-serif;",
                code: "Intro",
                name: "Intro"
            }, {
                params: "'Futura', sans-serif;",
                code: "Futura",
                name: "Futura"
            }, {
                params: "'JosefinSans-Bold', sans-serif;",
                code: "JosefinSans-Bold",
                name: "Josefin Sans"
            }, {
                params: "'Kalam-Bold', sans-serif;",
                code: "Kalam-Bold",
                name: "Kalam"
            }, {
                params: "'Lato-Regular', sans-serif;",
                code: "Lato-Regular",
                name: "Lato"
            }, {
                params: "'Lobster-Regular', sans-serif;",
                code: "Lobster-Regular",
                name: "Lobster"
            }, {
                params: "'Raleway-Bold', sans-serif;",
                code: "Raleway-Bold",
                name: "Raleway"
            }, {
                params: "'Bentoga', sans-serif;",
                code: "Bentoga-Thin",
                name: "Bentoga"
            }, {
                params: "'Brusher', sans-serif;",
                code: "Brusher",
                name: "Brusher"
            }, {
                params: "'Calistoga', sans-serif;",
                code: "Calistoga-Regular",
                name: "Calistoga"
            }, {
                params: "'Fondamento', sans-serif;",
                code: "Fondamento-Regular",
                name: "Fondamento"
            }, {
                params: "'Savoye LET', sans-serif;",
                code: "Savoye LET",
                name: "Savoye LET"
            }, {
                params: "'Homemade Apple', sans-serif;",
                code: "HomemadeApple-Regular",
                name: "Homemade Apple"
            }, {
                params: "'Luna', sans-serif;",
                code: "Luna",
                name: "Luna"
            }, {
                params: "'NewYork', sans-serif;",
                code: "NewYork",
                name: "NewYork"
            }, {
                params: "'Pathway Gothic', sans-serif;",
                code: "PathwayGothicOne-Regular",
                name: "Pathway Gothic"
            }, {
                params: "'Quattrocento', sans-serif;",
                code: "Quattrocento-Bold",
                name: "Quattrocento"
            }, {
                params: "'Syne', sans-serif;",
                code: "Syne-Bold",
                name: "Syne"
            }, {
                params: "'Thesignature', sans-serif;",
                code: "Thesignature",
                name: "Thesignature"
            }, {
                params: "'Tuesday Night', sans-serif;",
                code: "TuesdayNight-Regular",
                name: "Tuesday Night"
            }, {
                params: "'Yellowtail', sans-serif;",
                code: "Yellowtail-Regular",
                name: "Yellowtail"
            }, {
                params: "'Aegean', sans-serif;",
                code: "Aegean",
                name: "Aegean"
            }, {
                params: "'ALTA', sans-serif;",
                code: "Alta_regular",
                name: "ALTA"
            }, {
                params: "'Baskerville', sans-serif;",
                code: "Baskerville",
                name: "Baskerville"
            }, {
                params: "'Belleza', sans-serif;",
                code: "Belleza",
                name: "Belleza"
            }, {
                params: "'Black Mango', sans-serif;",
                code: "Black Mango",
                name: "Black Mango"
            }, {
                params: "'Catchy Mager', sans-serif;",
                code: "Catchy Mager",
                name: "Catchy Mager"
            }, {
                params: "'Hatton', sans-serif;",
                code: "Hatton",
                name: "Hatton"
            }, {
                params: "'HUOVA', sans-serif;",
                code: "HUOVA",
                name: "HUOVA"
            }, {
                params: "'Kudryashev', sans-serif;",
                code: "Kudryashev",
                name: "Kudryashev"
            }, {
                params: "'Laguna', sans-serif;",
                code: "Laguna",
                name: "Laguna"
            }, {
                params: "'Liana', sans-serif;",
                code: "Liana",
                name: "Liana"
            }, {
                params: "'Lovelace', sans-serif;",
                code: "Lovelace",
                name: "Lovelace"
            }, {
                params: "'Lovelo', sans-serif;",
                code: "Lovelo",
                name: "Lovelo"
            }, {
                params: "'Mak', sans-serif;",
                code: "Mak",
                name: "Mak"
            }, {
                params: "'Maragsa', sans-serif;",
                code: "Maragsa",
                name: "Maragsa"
            }, {
                params: "'Tan Pearl', sans-serif;",
                code: "Tan Pearl",
                name: "Tan Pearl"
            }, {
                params: "'Tenor', sans-serif;",
                code: "Tenor",
                name: "Tenor"
            }, {
                params: "'The Seasons', sans-serif;",
                code: "The Seasons",
                name: "The Seasons"
            }, {
                params: "'Allura', sans-serif;",
                code: "Allura",
                name: "Allura"
            }, {
                params: "'Alyssum', sans-serif;",
                code: "Alyssum",
                name: "Alyssum"
            }, {
                params: "'Bangers', sans-serif;",
                code: "Bangers",
                name: "Bangers"
            }, {
                params: "'Boulder', sans-serif;",
                code: "Boulder",
                name: "Boulder"
            }, {
                params: "'Carlson', sans-serif;",
                code: "Carlson",
                name: "Carlson"
            }, {
                params: "'Hello January', sans-serif;",
                code: "Hello January",
                name: "Hello January"
            }, {
                params: "'Hit and Run', sans-serif;",
                code: "Hit and Run",
                name: "Hit and Run"
            }, {
                params: "'Horta', sans-serif;",
                code: "Horta",
                name: "Horta"
            }, {
                params: "'Knewave', sans-serif;",
                code: "Knewave",
                name: "Knewave"
            }, {
                params: "'Lovelies', sans-serif;",
                code: "Lovelies",
                name: "Lovelies"
            }, {
                params: "'Monoton', sans-serif;",
                code: "Monoton",
                name: "Monoton"
            }, {
                params: "'Party Confetti', sans-serif;",
                code: "Party Confetti",
                name: "Party Confetti"
            }, {
                params: "'Peace', sans-serif;",
                code: "Peace",
                name: "Peace"
            }, {
                params: "'Petit Cochon', sans-serif;",
                code: "Petit Cochon",
                name: "Petit Cochon"
            }, {
                params: "'Playlist', sans-serif;",
                code: "Playlist",
                name: "Playlist"
            }, {
                params: "'Pushkin', sans-serif;",
                code: "Pushkin",
                name: "Pushkin"
            }, {
                params: "'Sarina', sans-serif;",
                code: "Sarina",
                name: "Sarina"
            }, {
                params: "'Shrikhand', sans-serif;",
                code: "Shrikhand",
                name: "Shrikhand"
            }, {
                params: "'Studly', sans-serif;",
                code: "Studly",
                name: "Studly"
            }, {
                params: "'The Youngest', sans-serif;",
                code: "The Youngest",
                name: "The Youngest"
            }, {
                params: "'Amsterdam One', sans-serif;",
                code: "Amsterdam One",
                name: "Amsterdam One"
            }, {
                params: "'Brittany', sans-serif;",
                code: "Brittany",
                name: "Brittany"
            }, {
                params: "'Daydream', sans-serif;",
                code: "Daydream",
                name: "Daydream"
            }, {
                params: "'Inters', sans-serif;",
                code: "Inters",
                name: "Inters"
            }, {
                params: "'Kavivanar', sans-serif;",
                code: "Kavivanar",
                name: "Kavivanar"
            }, {
                params: "'Mixa', sans-serif;",
                code: "Mixa",
                name: "Mixa"
            }, {
                params: "'Sisterhood', sans-serif;",
                code: "Sisterhood",
                name: "Sisterhood"
            }, {
                params: "'Virtual', sans-serif;",
                code: "Virtual",
                name: "Virtual"
            }, {
                params: "'Anton', sans-serif;",
                code: "Anton",
                name: "Anton"
            }, {
                params: "'Blue-Ocean', sans-serif;",
                code: "Blue Ocean",
                name: "Blue Ocean"
            }, {
                params: "'Cormorant', sans-serif;",
                code: "Cormorant",
                name: "Cormorant"
            }, {
                params: "'Culture', sans-serif;",
                code: "Culture",
                name: "Culture"
            }, {
                params: "'Keep-on-Truckin', sans-serif;",
                code: "Keep on Truckin",
                name: "Keep on Truckin"
            }, {
                params: "'Kingthings', sans-serif;",
                code: "Kingthings",
                name: "Kingthings"
            }, {
                params: "'Maharlika', sans-serif;",
                code: "Maharlika",
                name: "Maharlika"
            }, {
                params: "'Montserrat', sans-serif;",
                code: "Montserrat",
                name: "Montserrat"
            }, {
                params: "'Nectarine', sans-serif;",
                code: "Nectarine",
                name: "Nectarine"
            }, {
                params: "'Sandy', sans-serif;",
                code: "Sandy",
                name: "Sandy"
            }, {
                params: "'Tan-Paradiso', sans-serif;",
                code: "Tan-Paradiso",
                name: "Tan-Paradiso"
            }, {
                params: "'Well-Cake', sans-serif;",
                code: "Well-Cake",
                name: "Well-Cake"
            }, {
                params: "'Agrandir', sans-serif;",
                code: "Agrandir",
                name: "Agrandir"
            }, {
                params: "'BlackGold', sans-serif;",
                code: "BlackGold",
                name: "BlackGold"
            }, {
                params: "'Bright', sans-serif;",
                code: "Bright",
                name: "Bright"
            }, {
                params: "'Brown Sugar', sans-serif;",
                code: "Brown Sugar",
                name: "Brown Sugar"
            }, {
                params: "'Garet', sans-serif;",
                code: "Garet",
                name: "Garet"
            }, {
                params: "'Harmony', sans-serif;",
                code: "Harmony",
                name: "Harmony"
            }, {
                params: "'Migra', sans-serif;",
                code: "Migra",
                name: "Migra"
            }, {
                params: "'Migra Italic', sans-serif;",
                code: "Migra Italic",
                name: "Migra Italic"
            }, {
                params: "'Noto Serif Display', sans-serif;",
                code: "Noto Serif Display",
                name: "Noto Serif Display"
            }, {
                params: "'Pinyon Script', sans-serif;",
                code: "Pinyon Script",
                name: "Pinyon Script"
            }, {
                params: "'Sloop Script', sans-serif;",
                code: "Sloop Script",
                name: "Sloop Script"
            }, {
                params: "'Redkits', sans-serif;",
                code: "Redkits",
                name: "Redkits"
            }, {
                params: "'Sceageus', sans-serif;",
                code: "Sceageus",
                name: "Sceageus"
            }, {
                params: "'Tan Nimbus', sans-serif;",
                code: "Tan Nimbus",
                name: "Tan Nimbus"
            }, {
                params: "'Kenao', sans-serif;",
                code: "Kenao",
                name: "Kenao"
            }],
            animation_types: [{
                id: 0,
                name: "Без анимации"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Scale"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            collage_types: [{
                id: 0,
                name: "-",
                params: null
            }, {
                id: 1,
                name: "1/4",
                params: { x: 0, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 2,
                name: "2/4",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 3,
                name: "3/4",
                params: { x: 0, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 4,
                name: "4/4",
                params: { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 5,
                name: "1/3",
                params: { x: 0, y: 0, w: 1, h: 0.3333 }
            }, {
                id: 6,
                name: "2/3",
                params: { x: 0, y: 0.3333, w: 1, h: 0.3333 }
            }, {
                id: 7,
                name: "3/3",
                params: { x: 0, y: 0.6666, w: 1, h: 0.3333 }
            }, {
                id: 8,
                name: "1/2",
                params: { x: 0, y: 0, w: 1, h: 0.5 }
            }, {
                id: 9,
                name: "2/2",
                params: { x: 0, y: 0.5, w: 1, h: 0.5 }
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: []
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {
        var self = this;
        self.id = this.$route.params.id;

        // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
        var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

        var open = indexedDB.open("MuseDatabase");

        open.onupgradeneeded = function () {
            var db = open.result;
            var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
        };

        open.onsuccess = function () {
            // Start a new transaction
            var db = open.result;
            var tx = db.transaction("MuseObjectStore", "readwrite");
            var store = tx.objectStore("MuseObjectStore");
            var data = store.get(self.$storeVersion);

            data.onsuccess = function () {
                console.log(data.result);
                if (!data.result) {
                    self.getSVG();
                } else {
                    self.svg_list = data.result.object;
                    self.get(self.id);
                }
            };

            // Close the db when the transaction is done
            tx.oncomplete = function () {
                db.close();
            };
        };

        open.onerror = function (error) {
            console.log(error);
        };
    },
    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            _.map(this.client_parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return _.sortBy(this.fonts, function (f) {
                return f.name;
            });
        }
    },
    methods: {
        text_html: function text_html(index) {
            var textModel = this.template.texts[index];

            var text = _.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source) {
                return "";
            }

            var source = objectModel.source;

            var width = 100;
            var height = 100;
            var w = source.match(/width="\d{1,5}"/);
            var h = source.match(/height="\d{1,5}"/);
            if (w && h) {
                width = w[0].split('"')[1];
                height = h[0].split('"')[1];
            }

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            source = source.replace(/width="\d{1,4}"/, 'width="' + width + '"');
            source = source.replace(/height="\d{1,4}"/, 'height="' + height + '"');
            source = source.replace(/fill="black"/g, 'fill="' + objectModel.color + '"');
            source = source.replace(/stroke="black"/g, 'stroke="' + objectModel.color + '"');

            var style = ' style="opacity: ' + objectModel.alpha + '; border: 1px solid white; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '"';

            source = this.insertAt(source, style, 5);

            return source;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        goBack: function goBack() {
            window.history.back();
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index) {
            this.client_parts[index].start_time = this.client_parts[index].start_time.replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {

                if (self.is_object_changing) {
                    var obj = self.template.objects[self.active_object];
                    obj.id = object.id;
                    obj.source = object.source;
                    obj.category = object.category;
                } else {
                    var newObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_object));
                    newObj.id = object.id;
                    newObj.source = object.source;
                    newObj.category = object.category;
                    self.template.objects.push(newObj);
                    self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }

                self.is_object_changing = false;
                self.show_svg_modal = false;
            }

            self.active_object_category = 'arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                    self.video = self.$refs.videoContainer;

                    self.video.addEventListener("playing", function () {
                        //console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        //console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeCollageType: function changeCollageType(index, type) {

            if (type === 0) {
                this.client_parts[index].frame = null;
                return;
            }

            this.client_parts[index].frame = _.find(this.collage_types, function (c) {
                return c.id === type;
            }).params;
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    effect_values: { x: 0.5, y: 0.5 },
                    collage_type: 0,
                    frame: 0,
                    start_time: 0
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
            }, 30);
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/templates/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = response.data;

                for (var i = 0; i < data.templates[0].texts.length; i++) {
                    data.templates[0].texts[i].is_visible = 1;
                    if (data.templates[0].texts[i].time_start === undefined) {
                        data.templates[0].texts[i].time_start = 0;
                    }
                    if (data.templates[0].texts[i].time_end === undefined) {
                        data.templates[0].texts[i].time_end = "";
                    }

                    if (!data.templates[0].texts[i].direction) {
                        data.templates[0].texts[i].direction = "normal";
                    }

                    if (!data.templates[0].texts[i].animation_type) {
                        data.templates[0].texts[i].animation_type = 0;
                        data.templates[0].texts[i].animation_duration = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_blur) {
                        data.templates[0].texts[i].shadow_blur = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_alpha) {
                        data.templates[0].texts[i].shadow_alpha = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_color) {
                        data.templates[0].texts[i].shadow_color = '#ffffff';
                    }

                    if (!data.templates[0].texts[i].stroke_size) {
                        data.templates[0].texts[i].stroke_size = 0;
                    }

                    if (!data.templates[0].texts[i].stroke_size) {
                        data.templates[0].texts[i].stroke_color = '#000000';
                    }
                }

                for (var _i2 = 0; _i2 < data.templates[0].objects.length; _i2++) {
                    if (!data.templates[0].objects[_i2].animation_type) {
                        data.templates[0].objects[_i2].animation_type = 0;
                        data.templates[0].objects[_i2].animation_duration = 0;
                    }
                }

                self.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.templates[0]));

                self.template.parts.forEach(function (p) {
                    self.client_parts.push({
                        duration: p.duration,
                        speed: p.speed ? p.speed : "1.0",
                        effect_type: p.effect_type ? p.effect_type : 0,
                        effect_values: p.effect_values ? p.effect_values : { x: 0.5, y: 0.5 },
                        collage_type: p.collage_type ? p.collage_type : 0,
                        frame: p.frame ? p.frame : 0,
                        start_time: p.start_time ? p.start_time : 0
                    });
                });

                if (self.template.release_date) {
                    self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                    self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                } else {
                    self.template.release_time = '12:00';
                }

                if (self.template.song_insta) {
                    self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                }

                if (self.template.song_tiktok) {
                    self.template.song_tiktok = 'https://vt.tiktok.com/' + self.template.song_tiktok;
                }

                if (self.template.objects.length < 1) {
                    self.template.objects = [];
                    self.object_positions = [];
                } else {
                    var _loop = function _loop(_i3) {
                        self.object_positions.push(self.default_positions);

                        var svg = null;
                        _.forEach(self.svg_list, function (l) {
                            if (l.category === self.template.objects[_i3].category) {
                                svg = _.find(l.files, function (f) {
                                    return f.id === self.template.objects[_i3].id;
                                });
                            }
                        });

                        self.template.objects[_i3].is_visible = 1;

                        self.template.objects[_i3].source = svg ? svg.source : "<svg>Default Object</svg>";

                        setTimeout(function () {

                            var centerX = self.template.objects[_i3].position_x * 360 - self.$refs.draggableContainer2[_i3].clientWidth / 2;
                            var centerY = self.template.objects[_i3].position_y * 640 - self.$refs.draggableContainer2[_i3].clientHeight / 2;

                            self.$refs.draggableContainer2[_i3].style.left = centerX + 'px';
                            self.$refs.draggableContainer2[_i3].style.top = centerY + 'px';

                            self.video = self.$refs.videoContainer;

                            self.video.addEventListener("playing", function () {
                                //console.log('play ' + self.video.currentTime);

                                self.is_playing = true;
                            });

                            self.video.addEventListener("timeupdate", function () {
                                self.checkElementsVisibility(self.video.currentTime);
                            });

                            self.video.addEventListener("pause", function () {
                                //console.log('pause ' + self.video.currentTime);

                                self.is_playing = false;
                            });
                        }, 500);
                    };

                    for (var _i3 = 0; _i3 < self.template.objects.length; _i3++) {
                        _loop(_i3);
                    }
                }

                if (self.template.texts.length > 0) {

                    self.is_text_active = true;
                    self.active_text = 0;
                    self.active_type = 'text';

                    var _loop2 = function _loop2(_i4) {
                        self.positions.push(self.default_positions);

                        if (!self.template.texts[_i4].angle) {
                            self.template.texts[_i4].angle = 0;
                        }

                        setTimeout(function () {

                            var centerX = self.template.texts[_i4].position_x * 360 - self.$refs.draggableContainer[_i4].clientWidth / 2;
                            var centerY = self.template.texts[_i4].position_y * 640 - self.$refs.draggableContainer[_i4].clientHeight / 2;

                            self.$refs.draggableContainer[_i4].style.left = centerX + 'px';
                            self.$refs.draggableContainer[_i4].style.top = centerY + 'px';

                            self.video = self.$refs.videoContainer;

                            self.video.addEventListener("playing", function () {
                                //console.log('play ' + self.video.currentTime);

                                self.is_playing = true;
                            });

                            self.video.addEventListener("timeupdate", function () {
                                self.checkElementsVisibility(self.video.currentTime);
                            });

                            self.video.addEventListener("pause", function () {
                                //console.log('pause ' + self.video.currentTime);

                                self.is_playing = false;
                            });
                        }, 500);
                    };

                    for (var _i4 = 0; _i4 < self.template.texts.length; _i4++) {
                        _loop2(_i4);
                    }
                }
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'arrows';
            }
        },
        getSVG: function getSVG() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var self;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;


                                console.log('get SVG');

                                _this.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.$hostname + '/admin/services/svg', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + _this.token
                                    }
                                }).then(function (response) {

                                    self.svg_list = response.data;

                                    // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
                                    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

                                    var open = indexedDB.open("MuseDatabase");

                                    open.onupgradeneeded = function () {
                                        var db = open.result;
                                        var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
                                    };

                                    open.onsuccess = function () {
                                        // Start a new transaction
                                        var db = open.result;
                                        var tx = db.transaction("MuseObjectStore", "readwrite");
                                        var store = tx.objectStore("MuseObjectStore");

                                        // Add some data
                                        store.put({ id: self.$storeVersion, object: self.svg_list });

                                        // Close the db when the transaction is done
                                        tx.oncomplete = function () {
                                            db.close();
                                        };
                                    };

                                    open.onerror = function (error) {
                                        console.log(error);
                                    };

                                    self.get(self.id);

                                    self.waiting = false;
                                }).catch(function (error) {

                                    var notification = {
                                        template: '<span><b>\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 SVG \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        save: function save() {
            var _this2 = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var i = 0; i < self.template.texts.length; i++) {

                        var activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[i].offsetLeft + _this2.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[i].offsetTop + _this2.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[i] = activeText;
                    }

                    for (var _i5 = 0; _i5 < self.template.objects.length; _i5++) {

                        var activeObj = template.objects[_i5];

                        var _centerX = _this2.$refs.draggableContainer2[_i5].offsetLeft + _this2.$refs.draggableContainer2[_i5].clientWidth / 2;
                        var _centerY = _this2.$refs.draggableContainer2[_i5].offsetTop + _this2.$refs.draggableContainer2[_i5].clientHeight / 2;

                        activeObj.position_x = parseFloat((_centerX / 360).toFixed(4));
                        activeObj.position_y = parseFloat((_centerY / 640).toFixed(4));

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i5] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/templates/' + _this2.id + '/update', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    //                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        remove: function remove() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/templates/' + this.id + '/delete', this.template, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var notification = {
                    template: '<span><b>\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/templates');
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            _.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer2[this.draggable_index].offsetLeft + this.$refs.draggableContainer2[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer2[this.draggable_index].offsetTop + this.$refs.draggableContainer2[this.draggable_index].clientHeight / 2;

            this.template.objects[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.objects[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        }
    }
});

/***/ }),

/***/ "4pBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("PBKA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f50c6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("DRCg");
function injectStyle (ssrContext) {
  __webpack_require__("gTbC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f50c6e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f50c6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("/Bd9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Egk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.report)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.waiting }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'period')?_c('span',[_vm._v("Period")]):(column === 'my_feed')?_c('span',[_vm._v("My Feed, $")]):(column === 'muse')?_c('span',[_vm._v("Muse, $")]):(column === 'wallpapers')?_c('span',[_vm._v("Wallpapers, $")]):(column === 'imagine')?_c('span',[_vm._v("Imagine, $")]):(column === 'framy')?_c('span',[_vm._v("Framy, $")]):(column === 'marketing_spend')?_c('span',[_vm._v("Spend (Marketing, other), $")]):(column === 'summary')?_c('span',[_vm._v("Summary, $")]):_c('span')])})})],2),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.report.date_start)+" - "+_vm._s(_vm.report.date_end))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.info[0])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.info[1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.info[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.info[3])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.info[4])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.marketing_spend))+" ("+_vm._s(Intl.NumberFormat().format(_vm.report.other_spend))+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat().format(_vm.report.summary)))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.save()}}},[_vm._v("Сохранить")])])])])])])])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6h5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7707":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7AFY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("J6wH");
function injectStyle (ssrContext) {
  __webpack_require__("GhUe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7XHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Финансы")]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('fg-input',{attrs:{"type":"date","label":"Начальная дата","placeholder":""},on:{"input":function($event){return _vm.saveFilters('fi_date_start', _vm.start_date)}},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('fg-input',{attrs:{"type":"date","label":"Конечная дата","placeholder":""},on:{"input":function($event){return _vm.saveFilters('fi_date_end', _vm.end_date)}},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category_id),expression:"category_id"}],staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.category_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getSubcategories()}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.subcategory_id),expression:"subcategory_id"}],staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.subcategory_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('fi_subcategory', _vm.subcategory_id)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.subcategories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.project_id),expression:"project_id"}],staticClass:"form-control",attrs:{"multiple":"","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.project_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить запись\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'date')?_c('span',[_vm._v("Дата")]):(column === 'description')?_c('span',[_vm._v("Описание")]):(column === 'category_id')?_c('span',[_vm._v("Категория")]):(column === 'subcategory_id')?_c('span',[_vm._v("Подкатегория")]):(column === 'project_id')?_c('span',[_vm._v("Проект")]):(column === 'amount')?_c('span',[_vm._v("Сумма, $")]):_c('span')])})})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.data),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("toEasyDate")(item.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subcategory_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.project_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.amount)))]),_vm._v(" "),_c('td',[_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])])])])}),_vm._v(" "),_c('tr',{staticClass:"summary"},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary)))]),_vm._v(" "),_c('td')])],2)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7mcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__ = __webpack_require__("vwmR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01115e3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__ = __webpack_require__("rg7B");
function injectStyle (ssrContext) {
  __webpack_require__("v8vN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01115e3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01115e3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8l6I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9gRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__ = __webpack_require__("XcIV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__ = __webpack_require__("BUKW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_interaction__ = __webpack_require__("1WWl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
        FullCalendar: __WEBPACK_IMPORTED_MODULE_2__fullcalendar_vue__["a" /* default */]

    },
    created: function created() {
        this.get();
    },
    computed: {
        calendar: function calendar() {
            return this.$refs.fullCalendar.getApi();
        }
    },
    data: function data() {
        return {
            data: [],
            calendarOptions: {
                themeSystem: 'bootstrap',
                plugins: [__WEBPACK_IMPORTED_MODULE_3__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__fullcalendar_interaction__["a" /* default */]],
                initialView: 'dayGridMonth',
                aspectRatio: 2,
                locale: 'Ru',
                buttonText: {
                    today: 'Сегодня'
                },
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                eventContent: this.renderEventContent,
                renderEvent: this.renderEventContent,
                firstDay: 1,
                fixedWeekCount: false,
                events: []
            },
            role: parseInt(localStorage.getItem('role')) || 0,
            activeVideo: "",
            status: "1",
            waiting: false
        };
    },

    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/templates/calendar', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.data = response.data.templates;

                for (var i = 0; i < self.data.length; i++) {
                    var t = self.data[i];

                    self.calendar.addEvent({
                        id: t.id,
                        title: t.id,
                        start: t.release_date_history,
                        preview_url: t.src_full
                    });
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        renderEventContent: function renderEventContent(eventInfo) {
            var arrayOfDomNodes = [];

            var videoWrap = document.createElement('div');
            videoWrap.setAttribute('style', 'width: 100%;cursor: pointer;');

            videoWrap.innerHTML = '<div style="display: table; margin-left: 20px"><span style="color: black; font-weight: 700 !important; display:table-cell;\n' + ' vertical-align:middle;">ID: ' + eventInfo.event.id + '</span><video muted loop autoplay playsinline\n' + '                                                       style="width: 80px; margin-left: 20px; border-radius: 8px;">\n' + '                                                    <source src="' + eventInfo.event.extendedProps.preview_url + '"/>\n' + '                                                </video></div>';

            arrayOfDomNodes = [videoWrap];

            return { domNodes: arrayOfDomNodes };
        },
        renderEvent: function renderEvent(eventInfo) {
            console.log(eventInfo);
        },
        handleEventClick: function handleEventClick(arg) {
            if (this.role < 2) {
                this.$router.push({
                    name: 'edit-template',
                    params: { id: arg.event.id }
                });
            } else {
                this.activeVideo = arg.event.extendedProps.preview_url;
            }
        },
        closeVideo: function closeVideo() {
            this.activeVideo = "";
        },
        handleDateClick: function handleDateClick(arg) {
            return;
            var calendarApi = this.calendar;
            calendarApi.addEvent({
                id: 3,
                title: 'Meeting',
                start: '2024-04-01T14:30:00',
                image_url: '/static/img/premium.png'
            });
        }
    }
});

/***/ }),

/***/ "9rCB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AtX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Templates_vue__ = __webpack_require__("Eavv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5054c70f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Templates_vue__ = __webpack_require__("P+Su");
function injectStyle (ssrContext) {
  __webpack_require__("9rCB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5054c70f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Templates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5054c70f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Templates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CFEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.category_id),expression:"template.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"2.1"}},[_vm._v("2.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.2"}},[_vm._v("2.2")]),_vm._v(" "),_c('option',{attrs:{"value":"2.7"}},[_vm._v("2.7")]),_vm._v(" "),_c('option',{attrs:{"value":"2.8"}},[_vm._v("2.8")]),_vm._v(" "),_c('option',{attrs:{"value":"2.9"}},[_vm._v("2.9")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.1"}},[_vm._v("3.1")]),_vm._v(" "),_c('option',{attrs:{"value":"3.2"}},[_vm._v("3.2")]),_vm._v(" "),_c('option',{attrs:{"value":"3.3"}},[_vm._v("3.3")]),_vm._v(" "),_c('option',{attrs:{"value":"3.4"}},[_vm._v("3.4")]),_vm._v(" "),_c('option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('option',{attrs:{"value":"3.6"}},[_vm._v("3.6")]),_vm._v(" "),_c('option',{attrs:{"value":"3.7"}},[_vm._v("3.7")]),_vm._v(" "),_c('option',{attrs:{"value":"3.8"}},[_vm._v("3.8")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("4.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.1"}},[_vm._v("4.1")]),_vm._v(" "),_c('option',{attrs:{"value":"4.2"}},[_vm._v("4.2")]),_vm._v(" "),_c('option',{attrs:{"value":"4.3"}},[_vm._v("4.3")]),_vm._v(" "),_c('option',{attrs:{"value":"4.4"}},[_vm._v("4.4")]),_vm._v(" "),_c('option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('option',{attrs:{"value":"4.6"}},[_vm._v("4.6")]),_vm._v(" "),_c('option',{attrs:{"value":"5.0"}},[_vm._v("5.0")]),_vm._v(" "),_c('option',{attrs:{"value":"5.1"}},[_vm._v("5.1")]),_vm._v(" "),_c('option',{attrs:{"value":"5.2"}},[_vm._v("5.2")]),_vm._v(" "),_c('option',{attrs:{"value":"5.3"}},[_vm._v("5.3")]),_vm._v(" "),_c('option',{attrs:{"value":"5.4"}},[_vm._v("5.4")]),_vm._v(" "),_c('option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('option',{attrs:{"value":"5.6"}},[_vm._v("5.6")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trendy),expression:"template.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trendy)?_vm._i(_vm.template.is_trendy,null)>-1:(_vm.template.is_trendy)},on:{"change":function($event){var $$a=_vm.template.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trending-music-control"}},[_vm._v("Трендовая\n                                        музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trending_music),expression:"template.is_trending_music"}],staticClass:"form-check-inline",attrs:{"id":"trending-music-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trending_music)?_vm._i(_vm.template.is_trending_music,null)>-1:(_vm.template.is_trending_music)},on:{"change":function($event){var $$a=_vm.template.is_trending_music,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trending_music", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trending_music", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trending_music", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                        текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Видео: "),(_vm.template.src_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):(_vm.template.src_size >= 3)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"videoFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.videoFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Превью: "),(_vm.template.preview_src_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.template.audio_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.duration || !_vm.template.videos || !_vm.template.category_id || !_vm.template.song || !_vm.template.src || !_vm.template.preview_src || !_vm.template.audio
                                    || (_vm.template.is_copyrighted == true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),_c('card',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_text_active),expression:"is_text_active"}]},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                        Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                            "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (t.id))}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                            Копировать\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                        ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.category === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.category)}}},[_vm._v("\n                                            "+_vm._s(t.category === 'styled_shapes' ? 'Style shapes' : t.category)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('div',_vm._l((t.files),function(c,index){return (t.category === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (c.id))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].text_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                        "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":("static/objects/" + (_vm.template.objects[_vm.active_object].category) + "/" + (_vm.template.objects[_vm.active_object].id))},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0),expression:"template.objects[active_object].id.indexOf('nocolor') < 0"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template)?_c('div',{attrs:{"id":"preview-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.src_full),expression:"template.src_full"}],attrs:{"id":"player"}},[(!_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player","poster":_vm.template.preview_src_full},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),(_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player2"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                        Показать превью\n                                    ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты:\n                                ")]),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"#" + String(index + 1) + " - длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Коллаж")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].collage_type),expression:"client_parts[index].collage_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "collage_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeCollageType(index, _vm.client_parts[index].collage_type)}]}},_vm._l((_vm.collage_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index)}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e()]),_vm._v(" "),(_vm.client_parts[index].effect_type !== 0 && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                    'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])])})],2)])]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CKKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.model)?_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.getSubcategories()}]}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.subcategory_id),expression:"model.subcategory_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "subcategory_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subcategories),function(s){return _c('option',{domProps:{"value":s.id}},[_vm._v(_vm._s(s.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.project_id),expression:"model.project_id"}],staticClass:"form-control",attrs:{"multiple":"","id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Описание","placeholder":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сумма","placeholder":""},model:{value:(_vm.model.amount),callback:function ($$v) {_vm.$set(_vm.model, "amount", $$v)},expression:"model.amount"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата","placeholder":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.model.project_id || !_vm.model.amount || !_vm.model.category_id || !_vm.model.subcategory_id || !_vm.model.date},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CMwh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
    showSidebar: false,
    sidebarLinks: [{
        name: 'Dashboard',
        icon: 'ti-panel',
        path: '/admin/overview'
    }],
    displaySidebar: function displaySidebar(value) {
        this.showSidebar = value;
    }
};

var SidebarPlugin = {
    install: function install(Vue) {
        Vue.mixin({
            data: function data() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get: function get() {
                return this.$root.sidebarStore;
            }
        });
        Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
        Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "DGaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DRCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-component"},[_c('div',{staticClass:"full-page section-image",attrs:{"data-color":"black"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-offset-3 col-md-6 ml-auto mr-auto form-login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"card card-login"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body",class:{ shake: _vm.loginError }},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Пароль"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-wd",on:{"click":function($event){return _vm.login(_vm.username, _vm.password)}}},[_vm._v("Войти")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer ml-auto mr-auto"})])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background",style:({ backgroundImage: 'url(' + _vm.splash + ')' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DUIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("4SD2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a6a453_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("CFEU");
function injectStyle (ssrContext) {
  __webpack_require__("x+N7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34a6a453"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a6a453_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DomV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("uzar");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204fe654_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("aXPW");
function injectStyle (ssrContext) {
  __webpack_require__("6h5j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-204fe654"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204fe654_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("100 Awesome Nucleo Icons")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Handcrafted by our friends from "),_c('a',{attrs:{"target":"_blank","href":"https://nucleoapp.com/?ref=1712"}},[_vm._v("NucleoApp")])])]),_vm._v(" "),_c('div',{staticClass:"all-icons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-air-baloon"}),_vm._v(" "),_c('p',[_vm._v("nc-air-baloon")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("nc-album-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-alien-33"}),_vm._v(" "),_c('p',[_vm._v("nc-alien-33")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-center"}),_vm._v(" "),_c('p',[_vm._v("nc-align-center")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-left-2"}),_vm._v(" "),_c('p',[_vm._v("nc-align-left-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ambulance"}),_vm._v(" "),_c('p',[_vm._v("nc-ambulance")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-android"}),_vm._v(" "),_c('p',[_vm._v("nc-android")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-app"}),_vm._v(" "),_c('p',[_vm._v("nc-app")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("nc-apple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-atom"}),_vm._v(" "),_c('p',[_vm._v("nc-atom")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-attach-87"}),_vm._v(" "),_c('p',[_vm._v("nc-attach-87")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-audio-92"}),_vm._v(" "),_c('p',[_vm._v("nc-audio-92")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-backpack"}),_vm._v(" "),_c('p',[_vm._v("nc-backpack")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-badge"}),_vm._v(" "),_c('p',[_vm._v("nc-badge")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bag"}),_vm._v(" "),_c('p',[_vm._v("nc-bag")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bank"}),_vm._v(" "),_c('p',[_vm._v("nc-bank")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-battery-81"}),_vm._v(" "),_c('p',[_vm._v("nc-battery-81")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bell-55"}),_vm._v(" "),_c('p',[_vm._v("nc-bell-55")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bold"}),_vm._v(" "),_c('p',[_vm._v("nc-bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bulb-63"}),_vm._v(" "),_c('p',[_vm._v("nc-bulb-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("nc-bullet-list-67")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("nc-bus-front-12")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-pause"}),_vm._v(" "),_c('p',[_vm._v("nc-button-pause")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-play"}),_vm._v(" "),_c('p',[_vm._v("nc-button-play")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" "),_c('p',[_vm._v("nc-button-power")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-camera-20"}),_vm._v(" "),_c('p',[_vm._v("nc-camera-20")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-caps-small"}),_vm._v(" "),_c('p',[_vm._v("nc-caps-small")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cart-simple"}),_vm._v(" "),_c('p',[_vm._v("nc-cart-simple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("nc-cctv")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-bar-32")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-35"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-35")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-36"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-36")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart"}),_vm._v(" "),_c('p',[_vm._v("nc-chart")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chat-round"}),_vm._v(" "),_c('p',[_vm._v("nc-chat-round")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-check-2"}),_vm._v(" "),_c('p',[_vm._v("nc-check-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('p',[_vm._v("nc-circle-09")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle"}),_vm._v(" "),_c('p',[_vm._v("nc-circle")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-download-93"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-download-93")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-upload-94")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-compass-05"}),_vm._v(" "),_c('p',[_vm._v("nc-compass-05")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-controller-modern"}),_vm._v(" "),_c('p',[_vm._v("nc-controller-modern")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-credit-card"}),_vm._v(" "),_c('p',[_vm._v("nc-credit-card")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("nc-delivery-fast")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-83"}),_vm._v(" "),_c('p',[_vm._v("nc-email-83")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("nc-email-85")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-explore-2"}),_vm._v(" "),_c('p',[_vm._v("nc-explore-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-fav-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-fav-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-favourite-28"}),_vm._v(" "),_c('p',[_vm._v("nc-favourite-28")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-globe-2"}),_vm._v(" "),_c('p',[_vm._v("nc-globe-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-grid-45"}),_vm._v(" "),_c('p',[_vm._v("nc-grid-45")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-headphones-2"}),_vm._v(" "),_c('p',[_vm._v("nc-headphones-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-html5"}),_vm._v(" "),_c('p',[_vm._v("nc-html5")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-istanbul"}),_vm._v(" "),_c('p',[_vm._v("nc-istanbul")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-key-25"}),_vm._v(" "),_c('p',[_vm._v("nc-key-25")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-layers-3"}),_vm._v(" "),_c('p',[_vm._v("nc-layers-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("nc-light-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-lock-circle-open"}),_vm._v(" "),_c('p',[_vm._v("nc-lock-circle-open")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-map-big"}),_vm._v(" "),_c('p',[_vm._v("nc-map-big")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-mobile"}),_vm._v(" "),_c('p',[_vm._v("nc-mobile")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-money-coins"}),_vm._v(" "),_c('p',[_vm._v("nc-money-coins")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("nc-note-03")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("nc-notes")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("nc-notification-70")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-palette"}),_vm._v(" "),_c('p',[_vm._v("nc-palette")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-paper-2"}),_vm._v(" "),_c('p',[_vm._v("nc-paper-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-pin-3"}),_vm._v(" "),_c('p',[_vm._v("nc-pin-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-planet"}),_vm._v(" "),_c('p',[_vm._v("nc-planet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-preferences-circle-rotate"}),_vm._v(" "),_c('p',[_vm._v("nc-preferences-circle-rotate")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-puzzle-10"}),_vm._v(" "),_c('p',[_vm._v("nc-puzzle-10")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-quote"}),_vm._v(" "),_c('p',[_vm._v("nc-quote")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-refresh-02"}),_vm._v(" "),_c('p',[_vm._v("nc-refresh-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("nc-ruler-pencil")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-satisfied"}),_vm._v(" "),_c('p',[_vm._v("nc-satisfied")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-scissors"}),_vm._v(" "),_c('p',[_vm._v("nc-scissors")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-send"}),_vm._v(" "),_c('p',[_vm._v("nc-send")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-90"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-90")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-gear-64"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-gear-64")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-tool-66"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-tool-66")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-add"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-add")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-delete"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-delete")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-02"}),_vm._v(" "),_c('p',[_vm._v("nc-single-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("nc-single-copy-04")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-spaceship"}),_vm._v(" "),_c('p',[_vm._v("nc-spaceship")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-square-pin"}),_vm._v(" "),_c('p',[_vm._v("nc-square-pin")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-down"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-down")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-left"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-right"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-right")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-up"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-up")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-sun-fog-29"}),_vm._v(" "),_c('p',[_vm._v("nc-sun-fog-29")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-support-17"}),_vm._v(" "),_c('p',[_vm._v("nc-support-17")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tablet-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tablet-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tag-content"}),_vm._v(" "),_c('p',[_vm._v("nc-tag-content")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tap-01"}),_vm._v(" "),_c('p',[_vm._v("nc-tap-01")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-time-alarm"}),_vm._v(" "),_c('p',[_vm._v("nc-time-alarm")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tv-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tv-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-umbrella-13"}),_vm._v(" "),_c('p',[_vm._v("nc-umbrella-13")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-vector"}),_vm._v(" "),_c('p',[_vm._v("nc-vector")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("nc-watch-time")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-zoom-split"}),_vm._v(" "),_c('p',[_vm._v("nc-zoom-split")])])])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ERMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            is_object_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            active_object_category: 'arrows',
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                animation_type: 0,
                animation_duration: 0,
                time_end: "",
                is_visible: 1,
                angle: 0
            },
            texts: [],
            objects: [],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }, {
                params: "'Amsterdam Four', sans-serif;",
                code: "Amsterdam Four",
                name: "Amsterdam Four"
            }, {
                params: "'Bodoni 72', sans-serif;",
                code: "Bodoni 72",
                name: "Bodoni 72"
            }, {
                params: "'Courier New', sans-serif;",
                code: "Courier New",
                name: "Courier New"
            }, {
                params: "'Didot', sans-serif;",
                code: "Didot",
                name: "Didot"
            }, {
                params: "'Menlo', sans-serif;",
                code: "Menlo",
                name: "Menlo"
            }, {
                params: "'Optima', sans-serif;",
                code: "Optima",
                name: "Optima"
            }, {
                params: "'Copperplate Gothic Light', sans-serif;",
                code: "Copperplate Gothic Light",
                name: "Copperplate"
            }, {
                params: "'Avenir', sans-serif;",
                code: "Avenir",
                name: "Avenir"
            }, {
                params: "'AmaticSC-Bold', sans-serif;",
                code: "AmaticSC-Bold",
                name: "Amatic SC"
            }, {
                params: "'Zapfino', sans-serif;",
                code: "Zapfino",
                name: "Zapfino"
            }, {
                params: "'BebasNeue-Regular', sans-serif;",
                code: "BebasNeue-Regular",
                name: "Bebas Neue"
            }, {
                params: "'Noteworthy', sans-serif;",
                code: "Noteworthy",
                name: "Noteworthy"
            }, {
                params: "'DancingScript-Bold', sans-serif;",
                code: "DancingScript-Bold",
                name: "Dancing Script"
            }, {
                params: "'Chilanka-Regular', sans-serif;",
                code: "Chilanka-Regular",
                name: "Chilanka"
            }, {
                params: "'Intro', sans-serif;",
                code: "Intro",
                name: "Intro"
            }, {
                params: "'Futura', sans-serif;",
                code: "Futura",
                name: "Futura"
            }, {
                params: "'JosefinSans-Bold', sans-serif;",
                code: "JosefinSans-Bold",
                name: "Josefin Sans"
            }, {
                params: "'Kalam-Bold', sans-serif;",
                code: "Kalam-Bold",
                name: "Kalam"
            }, {
                params: "'Lato-Regular', sans-serif;",
                code: "Lato-Regular",
                name: "Lato"
            }, {
                params: "'Lobster-Regular', sans-serif;",
                code: "Lobster-Regular",
                name: "Lobster"
            }, {
                params: "'Raleway-Bold', sans-serif;",
                code: "Raleway-Bold",
                name: "Raleway"
            }, {
                params: "'Bentoga', sans-serif;",
                code: "Bentoga-Thin",
                name: "Bentoga"
            }, {
                params: "'Brusher', sans-serif;",
                code: "Brusher",
                name: "Brusher"
            }, {
                params: "'Calistoga', sans-serif;",
                code: "Calistoga-Regular",
                name: "Calistoga"
            }, {
                params: "'Fondamento', sans-serif;",
                code: "Fondamento-Regular",
                name: "Fondamento"
            }, {
                params: "'Savoye LET', sans-serif;",
                code: "Savoye LET",
                name: "Savoye LET"
            }, {
                params: "'Homemade Apple', sans-serif;",
                code: "HomemadeApple-Regular",
                name: "Homemade Apple"
            }, {
                params: "'Luna', sans-serif;",
                code: "Luna",
                name: "Luna"
            }, {
                params: "'NewYork', sans-serif;",
                code: "NewYork",
                name: "NewYork"
            }, {
                params: "'Pathway Gothic', sans-serif;",
                code: "PathwayGothicOne-Regular",
                name: "Pathway Gothic"
            }, {
                params: "'Quattrocento', sans-serif;",
                code: "Quattrocento-Bold",
                name: "Quattrocento"
            }, {
                params: "'Syne', sans-serif;",
                code: "Syne-Bold",
                name: "Syne"
            }, {
                params: "'Thesignature', sans-serif;",
                code: "Thesignature",
                name: "Thesignature"
            }, {
                params: "'Tuesday Night', sans-serif;",
                code: "TuesdayNight-Regular",
                name: "Tuesday Night"
            }, {
                params: "'Yellowtail', sans-serif;",
                code: "Yellowtail-Regular",
                name: "Yellowtail"
            }, {
                params: "'Aegean', sans-serif;",
                code: "Aegean",
                name: "Aegean"
            }, {
                params: "'ALTA', sans-serif;",
                code: "Alta_regular",
                name: "ALTA"
            }, {
                params: "'Baskerville', sans-serif;",
                code: "Baskerville",
                name: "Baskerville"
            }, {
                params: "'Belleza', sans-serif;",
                code: "Belleza",
                name: "Belleza"
            }, {
                params: "'Black Mango', sans-serif;",
                code: "Black Mango",
                name: "Black Mango"
            }, {
                params: "'Catchy Mager', sans-serif;",
                code: "Catchy Mager",
                name: "Catchy Mager"
            }, {
                params: "'Hatton', sans-serif;",
                code: "Hatton",
                name: "Hatton"
            }, {
                params: "'HUOVA', sans-serif;",
                code: "HUOVA",
                name: "HUOVA"
            }, {
                params: "'Kudryashev', sans-serif;",
                code: "Kudryashev",
                name: "Kudryashev"
            }, {
                params: "'Laguna', sans-serif;",
                code: "Laguna",
                name: "Laguna"
            }, {
                params: "'Liana', sans-serif;",
                code: "Liana",
                name: "Liana"
            }, {
                params: "'Lovelace', sans-serif;",
                code: "Lovelace",
                name: "Lovelace"
            }, {
                params: "'Lovelo', sans-serif;",
                code: "Lovelo",
                name: "Lovelo"
            }, {
                params: "'Mak', sans-serif;",
                code: "Mak",
                name: "Mak"
            }, {
                params: "'Maragsa', sans-serif;",
                code: "Maragsa",
                name: "Maragsa"
            }, {
                params: "'Tan Pearl', sans-serif;",
                code: "Tan Pearl",
                name: "Tan Pearl"
            }, {
                params: "'Tenor', sans-serif;",
                code: "Tenor",
                name: "Tenor"
            }, {
                params: "'The Seasons', sans-serif;",
                code: "The Seasons",
                name: "The Seasons"
            }, {
                params: "'Allura', sans-serif;",
                code: "Allura",
                name: "Allura"
            }, {
                params: "'Alyssum', sans-serif;",
                code: "Alyssum",
                name: "Alyssum"
            }, {
                params: "'Bangers', sans-serif;",
                code: "Bangers",
                name: "Bangers"
            }, {
                params: "'Boulder', sans-serif;",
                code: "Boulder",
                name: "Boulder"
            }, {
                params: "'Carlson', sans-serif;",
                code: "Carlson",
                name: "Carlson"
            }, {
                params: "'Hello January', sans-serif;",
                code: "Hello January",
                name: "Hello January"
            }, {
                params: "'Hit and Run', sans-serif;",
                code: "Hit and Run",
                name: "Hit and Run"
            }, {
                params: "'Horta', sans-serif;",
                code: "Horta",
                name: "Horta"
            }, {
                params: "'Knewave', sans-serif;",
                code: "Knewave",
                name: "Knewave"
            }, {
                params: "'Lovelies', sans-serif;",
                code: "Lovelies",
                name: "Lovelies"
            }, {
                params: "'Monoton', sans-serif;",
                code: "Monoton",
                name: "Monoton"
            }, {
                params: "'Party Confetti', sans-serif;",
                code: "Party Confetti",
                name: "Party Confetti"
            }, {
                params: "'Peace', sans-serif;",
                code: "Peace",
                name: "Peace"
            }, {
                params: "'Petit Cochon', sans-serif;",
                code: "Petit Cochon",
                name: "Petit Cochon"
            }, {
                params: "'Playlist', sans-serif;",
                code: "Playlist",
                name: "Playlist"
            }, {
                params: "'Pushkin', sans-serif;",
                code: "Pushkin",
                name: "Pushkin"
            }, {
                params: "'Sarina', sans-serif;",
                code: "Sarina",
                name: "Sarina"
            }, {
                params: "'Shrikhand', sans-serif;",
                code: "Shrikhand",
                name: "Shrikhand"
            }, {
                params: "'Studly', sans-serif;",
                code: "Studly",
                name: "Studly"
            }, {
                params: "'The Youngest', sans-serif;",
                code: "The Youngest",
                name: "The Youngest"
            }, {
                params: "'Amsterdam One', sans-serif;",
                code: "Amsterdam One",
                name: "Amsterdam One"
            }, {
                params: "'Brittany', sans-serif;",
                code: "Brittany",
                name: "Brittany"
            }, {
                params: "'Daydream', sans-serif;",
                code: "Daydream",
                name: "Daydream"
            }, {
                params: "'Inters', sans-serif;",
                code: "Inters",
                name: "Inters"
            }, {
                params: "'Kavivanar', sans-serif;",
                code: "Kavivanar",
                name: "Kavivanar"
            }, {
                params: "'Mixa', sans-serif;",
                code: "Mixa",
                name: "Mixa"
            }, {
                params: "'Sisterhood', sans-serif;",
                code: "Sisterhood",
                name: "Sisterhood"
            }, {
                params: "'Virtual', sans-serif;",
                code: "Virtual",
                name: "Virtual"
            }, {
                params: "'Anton', sans-serif;",
                code: "Anton",
                name: "Anton"
            }, {
                params: "'Blue-Ocean', sans-serif;",
                code: "Blue Ocean",
                name: "Blue Ocean"
            }, {
                params: "'Cormorant', sans-serif;",
                code: "Cormorant",
                name: "Cormorant"
            }, {
                params: "'Culture', sans-serif;",
                code: "Culture",
                name: "Culture"
            }, {
                params: "'Keep-on-Truckin', sans-serif;",
                code: "Keep on Truckin",
                name: "Keep on Truckin"
            }, {
                params: "'Kingthings', sans-serif;",
                code: "Kingthings",
                name: "Kingthings"
            }, {
                params: "'Maharlika', sans-serif;",
                code: "Maharlika",
                name: "Maharlika"
            }, {
                params: "'Montserrat', sans-serif;",
                code: "Montserrat",
                name: "Montserrat"
            }, {
                params: "'Nectarine', sans-serif;",
                code: "Nectarine",
                name: "Nectarine"
            }, {
                params: "'Sandy', sans-serif;",
                code: "Sandy",
                name: "Sandy"
            }, {
                params: "'Tan-Paradiso', sans-serif;",
                code: "Tan-Paradiso",
                name: "Tan-Paradiso"
            }, {
                params: "'Well-Cake', sans-serif;",
                code: "Well-Cake",
                name: "Well-Cake"
            }, {
                params: "'Agrandir', sans-serif;",
                code: "Agrandir",
                name: "Agrandir"
            }, {
                params: "'BlackGold', sans-serif;",
                code: "BlackGold",
                name: "BlackGold"
            }, {
                params: "'Bright', sans-serif;",
                code: "Bright",
                name: "Bright"
            }, {
                params: "'Brown Sugar', sans-serif;",
                code: "Brown Sugar",
                name: "Brown Sugar"
            }, {
                params: "'Garet', sans-serif;",
                code: "Garet",
                name: "Garet"
            }, {
                params: "'Harmony', sans-serif;",
                code: "Harmony",
                name: "Harmony"
            }, {
                params: "'Migra', sans-serif;",
                code: "Migra",
                name: "Migra"
            }, {
                params: "'Migra Italic', sans-serif;",
                code: "Migra Italic",
                name: "Migra Italic"
            }, {
                params: "'Noto Serif Display', sans-serif;",
                code: "Noto Serif Display",
                name: "Noto Serif Display"
            }, {
                params: "'Pinyon Script', sans-serif;",
                code: "Pinyon Script",
                name: "Pinyon Script"
            }, {
                params: "'Sloop Script', sans-serif;",
                code: "Sloop Script",
                name: "Sloop Script"
            }, {
                params: "'Redkits', sans-serif;",
                code: "Redkits",
                name: "Redkits"
            }, {
                params: "'Sceageus', sans-serif;",
                code: "Sceageus",
                name: "Sceageus"
            }, {
                params: "'Tan Nimbus', sans-serif;",
                code: "Tan Nimbus",
                name: "Tan Nimbus"
            }, {
                params: "'Kenao', sans-serif;",
                code: "Kenao",
                name: "Kenao"
            }],
            animation_types: [{
                id: 0,
                name: "Без анимации"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Scale"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: []
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {
        var self = this;
        self.id = this.$route.params.id;

        // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
        var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

        var open = indexedDB.open("MuseDatabase");

        open.onupgradeneeded = function () {
            var db = open.result;
            var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
        };

        open.onsuccess = function () {
            // Start a new transaction
            var db = open.result;
            var tx = db.transaction("MuseObjectStore", "readwrite");
            var store = tx.objectStore("MuseObjectStore");
            var data = store.get(self.$storeVersion);

            data.onsuccess = function () {
                console.log(data.result);
                if (!data.result) {
                    self.getSVG();
                } else {
                    self.svg_list = data.result.object;
                    self.get(self.id);
                }
            };

            // Close the db when the transaction is done
            tx.oncomplete = function () {
                db.close();
            };
        };

        open.onerror = function (error) {
            console.log(error);
        };
    },
    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            _.map(this.client_parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return _.sortBy(this.fonts, function (f) {
                return f.name;
            });
        }
    },
    methods: {
        text_html: function text_html(index) {
            var textModel = this.template.texts[index];

            var text = _.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source) {
                return "";
            }

            var source = objectModel.source;

            var width = 100;
            var height = 100;
            var w = source.match(/width="\d{1,5}"/);
            var h = source.match(/height="\d{1,5}"/);
            if (w && h) {
                width = w[0].split('"')[1];
                height = h[0].split('"')[1];
            }

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            source = source.replace(/width="\d{1,4}"/, 'width="' + width + '"');
            source = source.replace(/height="\d{1,4}"/, 'height="' + height + '"');
            source = source.replace(/fill="black"/g, 'fill="' + objectModel.color + '"');
            source = source.replace(/stroke="black"/g, 'stroke="' + objectModel.color + '"');

            var style = ' style="opacity: ' + objectModel.alpha + '; border: 1px solid white; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '"';

            source = this.insertAt(source, style, 5);

            return source;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        goBack: function goBack() {
            window.history.back();
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {

                if (self.is_object_changing) {
                    var obj = self.template.objects[self.active_object];
                    obj.id = object.id;
                    obj.source = object.source;
                    obj.category = object.category;
                } else {
                    var newObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_object));
                    newObj.id = object.id;
                    newObj.source = object.source;
                    newObj.category = object.category;
                    self.template.objects.push(newObj);
                    self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }

                self.is_object_changing = false;
                self.show_svg_modal = false;
            }

            self.active_object_category = 'arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    effect_values: { x: 0.5, y: 0.5 }
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
                if (self.template.duration && self.video.currentTime >= self.template.duration) {
                    self.video.load();
                }
            }, 30);
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/created/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = response.data;

                for (var i = 0; i < data.templates[0].texts.length; i++) {
                    data.templates[0].texts[i].is_visible = 1;
                    if (data.templates[0].texts[i].time_start === undefined) {
                        data.templates[0].texts[i].time_start = 0;
                    }
                    if (data.templates[0].texts[i].time_end === undefined) {
                        data.templates[0].texts[i].time_end = "";
                    }

                    if (!data.templates[0].texts[i].direction) {
                        data.templates[0].texts[i].direction = "normal";
                    }

                    if (!data.templates[0].texts[i].animation_type) {
                        data.templates[0].texts[i].animation_type = 0;
                        data.templates[0].texts[i].animation_duration = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_blur) {
                        data.templates[0].texts[i].shadow_blur = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_alpha) {
                        data.templates[0].texts[i].shadow_alpha = 0;
                    }

                    if (!data.templates[0].texts[i].shadow_color) {
                        data.templates[0].texts[i].shadow_color = '#ffffff';
                    }

                    if (!data.templates[0].texts[i].stroke_size) {
                        data.templates[0].texts[i].stroke_size = 0;
                    }

                    if (!data.templates[0].texts[i].stroke_size) {
                        data.templates[0].texts[i].stroke_color = '#000000';
                    }
                }

                for (var _i2 = 0; _i2 < data.templates[0].objects.length; _i2++) {
                    if (!data.templates[0].objects[_i2].animation_type) {
                        data.templates[0].objects[_i2].animation_type = 0;
                        data.templates[0].objects[_i2].animation_duration = 0;
                    }
                }

                self.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.templates[0]));

                self.template.parts.forEach(function (p) {
                    self.client_parts.push({
                        duration: p.duration,
                        speed: p.speed ? p.speed : "1.0",
                        effect_type: p.effect_type ? p.effect_type : 0,
                        effect_values: p.effect_values ? p.effect_values : { x: 0.5, y: 0.5 }
                    });
                });

                if (self.template.release_date) {
                    self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                    self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                } else {
                    self.template.release_time = '12:00';
                }

                if (self.template.song_insta) {
                    self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                }

                if (self.template.song_tiktok) {
                    self.template.song_tiktok = 'https://vt.tiktok.com/' + self.template.song_tiktok;
                }

                if (self.template.objects.length < 1) {
                    self.template.objects = [];
                    self.object_positions = [];
                } else {
                    var _loop = function _loop(_i3) {
                        self.object_positions.push(self.default_positions);

                        var svg = null;
                        _.forEach(self.svg_list, function (l) {
                            if (l.category === self.template.objects[_i3].category) {
                                svg = _.find(l.files, function (f) {
                                    return f.id === self.template.objects[_i3].id;
                                });
                            }
                        });

                        self.template.objects[_i3].is_visible = 1;

                        self.template.objects[_i3].source = svg ? svg.source : "<svg>Default Object</svg>";

                        setTimeout(function () {

                            var centerX = self.template.objects[_i3].position_x * 360 - self.$refs.draggableContainer2[_i3].clientWidth / 2;
                            var centerY = self.template.objects[_i3].position_y * 640 - self.$refs.draggableContainer2[_i3].clientHeight / 2;

                            self.$refs.draggableContainer2[_i3].style.left = centerX + 'px';
                            self.$refs.draggableContainer2[_i3].style.top = centerY + 'px';

                            self.video = self.$refs.videoContainer;

                            self.video.addEventListener("playing", function () {
                                //console.log('play ' + self.video.currentTime);

                                self.is_playing = true;
                            });

                            self.video.addEventListener("timeupdate", function () {
                                self.checkElementsVisibility(self.video.currentTime);
                            });

                            self.video.addEventListener("pause", function () {
                                //console.log('pause ' + self.video.currentTime);

                                self.is_playing = false;
                            });
                        }, 500);
                    };

                    for (var _i3 = 0; _i3 < self.template.objects.length; _i3++) {
                        _loop(_i3);
                    }
                }

                if (self.template.texts.length > 0) {

                    self.is_text_active = true;
                    self.active_text = 0;
                    self.active_type = 'text';

                    var _loop2 = function _loop2(_i4) {
                        self.positions.push(self.default_positions);

                        if (!self.template.texts[_i4].angle) {
                            self.template.texts[_i4].angle = 0;
                        }

                        setTimeout(function () {

                            var centerX = self.template.texts[_i4].position_x * 360 - self.$refs.draggableContainer[_i4].clientWidth / 2;
                            var centerY = self.template.texts[_i4].position_y * 640 - self.$refs.draggableContainer[_i4].clientHeight / 2;

                            self.$refs.draggableContainer[_i4].style.left = centerX + 'px';
                            self.$refs.draggableContainer[_i4].style.top = centerY + 'px';

                            self.video = self.$refs.videoContainer;

                            self.video.addEventListener("playing", function () {
                                //console.log('play ' + self.video.currentTime);

                                self.is_playing = true;
                            });

                            self.video.addEventListener("timeupdate", function () {
                                self.checkElementsVisibility(self.video.currentTime);
                            });

                            self.video.addEventListener("pause", function () {
                                //console.log('pause ' + self.video.currentTime);

                                self.is_playing = false;
                            });
                        }, 500);
                    };

                    for (var _i4 = 0; _i4 < self.template.texts.length; _i4++) {
                        _loop2(_i4);
                    }
                }
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'arrows';
            }
        },
        getSVG: function getSVG() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var self;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;


                                console.log('get SVG');

                                _this.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.$hostname + '/admin/services/svg', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + _this.token
                                    }
                                }).then(function (response) {

                                    self.svg_list = response.data;

                                    // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
                                    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

                                    var open = indexedDB.open("MuseDatabase");

                                    open.onupgradeneeded = function () {
                                        var db = open.result;
                                        var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
                                    };

                                    open.onsuccess = function () {
                                        // Start a new transaction
                                        var db = open.result;
                                        var tx = db.transaction("MuseObjectStore", "readwrite");
                                        var store = tx.objectStore("MuseObjectStore");

                                        // Add some data
                                        store.put({ id: self.$storeVersion, object: self.svg_list });

                                        // Close the db when the transaction is done
                                        tx.oncomplete = function () {
                                            db.close();
                                        };
                                    };

                                    open.onerror = function (error) {
                                        console.log(error);
                                    };

                                    self.get(self.id);

                                    self.waiting = false;
                                }).catch(function (error) {

                                    var notification = {
                                        template: '<span><b>\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 SVG \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        save: function save() {
            var _this2 = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            for (var i = 0; i < template.parts.length; i++) {
                if (template.parts[i].duration === null || template.parts[i].speed === null) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (Math.abs(self.sumParts - template.duration) > 0.05) {

                var _notification3 = {
                    template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification3,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (this.video) {
                this.video.load();
            }

            self.waiting = true;
            //console.log(self.template.texts);
            //return false;
            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var _i5 = 0; _i5 < self.template.texts.length; _i5++) {

                        var activeText = template.texts[_i5];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[_i5].offsetLeft + _this2.$refs.draggableContainer[_i5].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[_i5].offsetTop + _this2.$refs.draggableContainer[_i5].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[_i5] = activeText;
                    }

                    for (var _i6 = 0; _i6 < self.template.objects.length; _i6++) {

                        var activeObj = template.objects[_i6];

                        var _centerX = _this2.$refs.draggableContainer2[_i6].offsetLeft + _this2.$refs.draggableContainer2[_i6].clientWidth / 2;
                        var _centerY = _this2.$refs.draggableContainer2[_i6].offsetTop + _this2.$refs.draggableContainer2[_i6].clientHeight / 2;

                        activeObj.position_x = parseFloat((_centerX / 360).toFixed(4));
                        activeObj.position_y = parseFloat((_centerY / 640).toFixed(4));

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i6] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/created/' + _this2.id + '/update', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    //                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        remove: function remove() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/created/' + this.id + '/delete', this.template, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                var notification = {
                    template: '<span><b>\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/memories');
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            _.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer2[this.draggable_index].offsetLeft + this.$refs.draggableContainer2[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer2[this.draggable_index].offsetTop + this.$refs.draggableContainer2[this.draggable_index].clientHeight / 2;

            this.template.objects[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.objects[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        }
    }
});

/***/ }),

/***/ "EZIe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.get();
    },
    data: function data() {
        return {
            data: [],
            activeVideo: "",
            status: "1",
            waiting: false,
            categoryId: 998,
            categories: [{
                id: 1,
                name: '11'
            }, {
                id: 2,
                name: '22'
            }, {
                id: 3,
                name: '33'
            }, {
                id: 4,
                name: '44'
            }]
        };
    },

    methods: {
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.get(this.$hostname + '/admin/templates/preview', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                self.data = response.data;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        save: function save() {
            var self = this;

            var token = localStorage.getItem('token');

            self.waiting = true;

            axios.post(this.$hostname + '/admin/templates/preview/resort', {
                data: this.data
            }, {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.waiting = false;
                console.log(response);
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        getTemplateSrc: function getTemplateSrc(src) {
            return src;
        },
        getTemplateType: function getTemplateType() {
            return 'video/mp4';
        },
        showTemplates: function showTemplates(categoryId) {
            console.log(categoryId);
        },
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        openVideo: function openVideo(src) {
            this.activeVideo = src;
        },
        closeVideo: function closeVideo() {
            this.activeVideo = "";
        }
    }
});

/***/ }),

/***/ "Eavv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__("M4fF");
var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        var self = this;

        var token = localStorage.getItem('token');

        axios.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (response) {
            self.loading = false;
            self.categories = response.data;

            self.get();
        }).catch(function (error) {
            self.loading = false;
            console.log(error);
        });
    },
    data: function data() {
        return {
            columns: ['id', 'category', 'preview_src_full', 'is_premium', 'is_trendy', 'videos', 'duration', 'sort', 'status', ''],
            data: [],
            role: parseInt(localStorage.getItem('role')) || 0,
            categoryId: localStorage.getItem('tt_category') ? localStorage.getItem('tt_category') : "",
            status: localStorage.getItem('tt_status') ? localStorage.getItem('tt_status') : "",
            isTrendy: localStorage.getItem('tt_is_trendy') ? localStorage.getItem('tt_is_trendy') : "",
            isCopyrighted: localStorage.getItem('tt_is_copyrighted') ? localStorage.getItem('tt_is_copyrighted') : "",
            isNew: localStorage.getItem('tt_is_new') ? localStorage.getItem('tt_is_new') : "",
            categories: [],
            filteredId: null,
            activeVideo: "",
            songId: null,
            limit: 10,
            offset: parseInt(localStorage.getItem('tt_active_offset')) || 0,
            stats: {
                templatesCount: 0,
                freeTemplatesCount: 0,
                premiumTemplatesCount: 0,
                averageTemplateCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            }
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        },
        toShortText: function toShortText(value) {
            if (value) {
                return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10);
            } else {
                return '';
            }
        }
    },
    methods: {
        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        resetStatsCount: function resetStatsCount() {
            this.stats = {
                templatesCount: 0,
                freeTemplatesCount: 0,
                premiumTemplatesCount: 0,
                averageTemplateCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            };
        },
        add: function add() {
            this.$router.push('/templates/create');
        },
        filter: function filter() {
            localStorage.setItem('tt_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        edit: function edit(id) {
            if (this.role > 1) {
                return false;
            }
            //localStorage.setItem('w_last_opened_id', parseInt(id));
            this.$router.push({
                name: 'edit-template',
                params: { id: id }
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var categoryId = this.categoryId === null ? '' : this.categoryId;
            var status = this.status === null ? '' : this.status;
            var isTrendy = this.isTrendy === null ? '' : this.isTrendy;
            var isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
            var isNew = this.isNew === null ? '' : this.isNew;
            var filteredId = this.filteredId === null ? '' : this.filteredId;
            var songId = this.songId === null ? '' : this.songId;

            self.resetStatsCount();

            axios.get(this.$hostname + '/admin/templates', {
                'params': {
                    categoryId: categoryId,
                    status: status,
                    isTrendy: isTrendy,
                    isCopyrighted: isCopyrighted,
                    isNew: isNew,
                    limit: self.limit,
                    offset: self.offset,
                    filteredId: filteredId,
                    songName: songId

                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;

                self.data = data.templates;

                //let dataStats = _.filter(data.templates, t => t.status === 1);

                self.stats.templatesCount = data.templates_count;
                self.stats.premiumTemplatesCount = data.premium_count;
                self.stats.freeTemplatesCount = data.templates_count - data.premium_count;

                self.stats.averageFreeCount = (self.stats.freeTemplatesCount / self.categories.length).toFixed(2);
                self.stats.averagePremiumCount = (self.stats.premiumTemplatesCount / self.categories.length).toFixed(2);
                self.stats.averageTemplateCount = (self.stats.templatesCount / self.categories.length).toFixed(2);
            }).catch(function (error) {
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('tt_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('tt_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        },
        openVideo: function openVideo(src) {
            if (this.role > 1) {
                this.activeVideo = src;
            }
        },
        closeVideo: function closeVideo() {
            this.activeVideo = "";
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('templates') < 1) {
            localStorage.setItem('tt_active_offset', "0");
            localStorage.setItem('tt_category', "");
            localStorage.setItem('tt_status', "");
            localStorage.setItem('tt_is_trendy', "");
            localStorage.setItem('tt_is_new', "");
            localStorage.setItem('tt_is_copyrighted', "");
        }
        next();
    }
});

/***/ }),

/***/ "FfxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.track)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярный")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_trendy),expression:"track.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_trendy)?_vm._i(_vm.track.is_trendy,null)>-1:(_vm.track.is_trendy)},on:{"change":function($event){var $$a=_vm.track.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id !== 999)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","readonly":"","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G0RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('b',{staticClass:"caret"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5 Notifications")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 1")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 2")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 3")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 4")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another notification")])],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"title":"Dropdown"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something else here")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Separated link")])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('i',{staticClass:"nc-icon nc-zoom-split hidden-lg-up"}),_vm._v(" "),_c('span',{staticClass:"d-lg-none"},[_vm._v("Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Выйти")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GRHK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ga2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.project_id),expression:"task.project_id"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"9"}},[_vm._v("Muse")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Премиум")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.is_premium),expression:"task.is_premium"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "is_premium", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Премиум")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Не премиум")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.version),expression:"task.version"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.task, "version", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"4.4"}},[_vm._v("4.4")]),_vm._v(" "),_c('option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('option',{attrs:{"value":"4.6"}},[_vm._v("4.6")]),_vm._v(" "),_c('option',{attrs:{"value":"5.0"}},[_vm._v("5.0")]),_vm._v(" "),_c('option',{attrs:{"value":"5.1"}},[_vm._v("5.1")]),_vm._v(" "),_c('option',{attrs:{"value":"5.2"}},[_vm._v("5.2")]),_vm._v(" "),_c('option',{attrs:{"value":"5.3"}},[_vm._v("5.3")]),_vm._v(" "),_c('option',{attrs:{"value":"5.4"}},[_vm._v("5.4")]),_vm._v(" "),_c('option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('option',{attrs:{"value":"5.6"}},[_vm._v("5.6")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"ID рассылки","placeholder":""},model:{value:(_vm.task.push_payload.id),callback:function ($$v) {_vm.$set(_vm.task.push_payload, "id", $$v)},expression:"task.push_payload.id"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"ID шаблона","placeholder":""},model:{value:(_vm.task.push_payload.template_id),callback:function ($$v) {_vm.$set(_vm.task.push_payload, "template_id", $$v)},expression:"task.push_payload.template_id"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Токен (оставить пустым, чтобы отправить всем пользователям)","placeholder":""},model:{value:(_vm.task.token),callback:function ($$v) {_vm.$set(_vm.task, "token", $$v)},expression:"task.token"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата отправки (дата пользователя, когда ему придет пуш)","placeholder":""},model:{value:(_vm.client_release_date),callback:function ($$v) {_vm.client_release_date=$$v},expression:"client_release_date"}}),_vm._v(" "),(_vm.client_release_date && _vm.client_release_date.indexOf('null') < 0)?_c('fg-input',{attrs:{"type":"time","label":"Время отправки (время пользователя, когда ему придет пуш)","placeholder":""},model:{value:(_vm.client_release_time),callback:function ($$v) {_vm.client_release_time=$$v},expression:"client_release_time"}}):_vm._e()],1)]),_vm._v(" "),(_vm.locales[0])?_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.locales[0].title && !_vm.locales[0].text},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.task)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content locale-section"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"locale-block"},[_vm._v(_vm._s(itm.code))]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Тайтл","placeholder":""},model:{value:(_vm.locales[index].title),callback:function ($$v) {_vm.$set(_vm.locales[index], "title", $$v)},expression:"locales[index].title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Текст","placeholder":""},model:{value:(_vm.locales[index].text),callback:function ($$v) {_vm.$set(_vm.locales[index], "text", $$v)},expression:"locales[index].text"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GfbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.album)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество треков в альбоме","placeholder":"","readonly":""},model:{value:(_vm.album.tracks_number),callback:function ($$v) {_vm.$set(_vm.album, "tracks_number", $$v)},expression:"album.tracks_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.album.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.album.image_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):(_vm.album.image_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.album.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GhUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hz/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов в категории","placeholder":"","readonly":""},model:{value:(_vm.category.templates),callback:function ($$v) {_vm.$set(_vm.category, "templates", $$v)},expression:"category.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IRFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IZnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("ERMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc08e2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("pYwg");
function injectStyle (ssrContext) {
  __webpack_require__("3C/Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdc08e2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdc08e2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J6wH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar.apply(null, arguments)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",function(){return [(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JnQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество шаблонов в категории","placeholder":"","readonly":""},model:{value:(_vm.category.templates),callback:function ($$v) {_vm.$set(_vm.category, "templates", $$v)},expression:"category.templates"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JniN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("qg9l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75df9b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("tyJc");
function injectStyle (ssrContext) {
  __webpack_require__("mx5O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75df9b74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75df9b74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KGJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kmkn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L5W5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LAba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M+AW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: null,
            albums: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get(self.id);
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tracks/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.locales, function (l) {

                    var tModel = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tracks/' + this.id + '/update', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/tracks');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration);

                    var minutes = Math.floor(data.duration / 60).toString();
                    var seconds = data.duration % 60 < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c51b0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+cI5");
function injectStyle (ssrContext) {
  __webpack_require__("uT4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c51b0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "MFnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",function(){return [_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("NTbq");
function injectStyle (ssrContext) {
  __webpack_require__("Qf8J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
    },
    props: {
        title: {
            type: String,
            default: 'MUSE'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: function validator(value) {
                var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        backgroundImage: {
            type: String,
            default: '/static/img/muse1.jpg'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: function validator(value) {
                var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        sidebarLinks: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide: function provide() {
        return {
            autoClose: this.autoClose
        };
    },

    computed: {
        sidebarStyle: function sidebarStyle() {
            return {
                backgroundImage: 'url(' + this.backgroundImage + ')'
            };
        }
    }
});

/***/ }),

/***/ "Mpri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mt/T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NAs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__ = __webpack_require__("oMSU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16526d25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__ = __webpack_require__("yyh4");
function injectStyle (ssrContext) {
  __webpack_require__("DGaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16526d25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16526d25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_routes__ = __webpack_require__("T1vP");





// LightBootstrap plugin


// router setup

// plugin setup
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__["a" /* default */]);

// configure router
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_5__routes_routes__["a" /* default */], // short for routes: routes
    linkActiveClass: 'nav-item active',
    mode: 'hash'
});

function nextFactory(context, middleware, index) {
    var subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
        return context.next;
    }

    return function () {
        context.next.apply(context, arguments);

        var nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    };
}

router.beforeEach(function (to, from, next) {
    if (to.meta.middleware) {
        var middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        var context = {
            from: from,
            next: next,
            router: router,
            to: to
        };

        var nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    }

    return next();
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$hostname = "https://templates.bigrowth.io";
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$storeVersion = 7;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
    },
    router: router
});

/***/ }),

/***/ "NTbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            bigrowth team.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NWP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("blLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d61f871_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("WrYa");
function injectStyle (ssrContext) {
  __webpack_require__("7AFY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d61f871"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d61f871_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1937eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("yiba");
function injectStyle (ssrContext) {
  __webpack_require__("eApH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1937eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OprI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("TiXa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f6ce1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("JnQw");
function injectStyle (ssrContext) {
  __webpack_require__("Mpri")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67f6ce1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f6ce1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OrYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracks_vue__ = __webpack_require__("dePQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccd67a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracks_vue__ = __webpack_require__("vQaE");
function injectStyle (ssrContext) {
  __webpack_require__("/p5S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ccd67a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccd67a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P+Su":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Шаблоны")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row stats-block mt10"},[_c('span',[_vm._v("Количество категорий: "),_c('span',{staticClass:"number"},[(_vm.categories)?_c('span',[_vm._v(_vm._s(_vm.categories.length))]):_vm._e()])]),_vm._v(" "),_c('span',[_vm._v("Количество опубликованных шаблонов: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.templatesCount))]),_vm._v(" ("),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.freeTemplatesCount))]),_vm._v(" - бесплатных, "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.premiumTemplatesCount))]),_vm._v(" - премиум) ")]),_vm._v(" "),_c('span',[_vm._v("Среднее количество шаблонов в категории: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.averageTemplateCount))]),_vm._v(" ("),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.averageFreeCount))]),_vm._v(" - бесплатных, "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stats.averagePremiumCount))]),_vm._v(" - премиум) ")])]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Популярное")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isTrendy),expression:"isTrendy"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isTrendy=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_is_trendy', _vm.isTrendy)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Популярное")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Copyrighted")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCopyrighted),expression:"isCopyrighted"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isCopyrighted=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_is_copyrighted', _vm.isCopyrighted)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Free")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Copyrighted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("New")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isNew),expression:"isNew"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isNew=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('tt_is_new', _vm.isNew)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("New")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по ID","placeholder":""},model:{value:(_vm.filteredId),callback:function ($$v) {_vm.filteredId=$$v},expression:"filteredId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по песне","placeholder":""},model:{value:(_vm.songId),callback:function ($$v) {_vm.songId=$$v},expression:"songId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),(_vm.role < 2)?_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить шаблон\n                                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'preview_src_full')?_c('span',[_vm._v("превью")]):(column === 'counter')?_c('span',[_vm._v("экспорт")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'videos')?_c('span',[_vm._v("количество видео")]):(column === 'duration')?_c('span',[_vm._v("длительность, сек.")]):(column === 'release_date')?_c('span',[_vm._v("дата публикации")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_trendy')?_c('span',[_vm._v("популярное")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'preview_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(!_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",on:{"click":function($event){$event.preventDefault();return _vm.openVideo(item['src_full'])}}},[_c('video',{key:item[column],staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":item[column]}})])]):_vm._e()]):(column === 'color'  && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'color_group' && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === '')?_c('span',[(_vm.role < 2)?_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]):_vm._e()]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Опубликовано")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Ожидает")]):_vm._e()]):(column === 'release_date')?_c('span',{},[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'duration')?_c('span',{},[_c('span',[_vm._v(_vm._s(item[column]))])]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === 'type')?_c('span',[(item[column] === 2)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/live.png"}}):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n                    Закрыть\n                ")])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P827":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__ = __webpack_require__("Vg8q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01317ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__ = __webpack_require__("7XHD");
function injectStyle (ssrContext) {
  __webpack_require__("e3EN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e01317ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01317ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("TRiL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69420d39_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("CKKM");
function injectStyle (ssrContext) {
  __webpack_require__("vKl8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69420d39"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69420d39_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            categories: [],
            username: 'admin',
            password: '',
            loginError: false,
            //splash: '/static/img/backgrounds/' + Math.floor((Math.random() * (5 - 1) + 1)).toString() + '.jpg'
            splash: '/static/img/backgrounds/3.jpg'
        };
    },

    created: function created() {
        if (localStorage.getItem('token')) {
            this.$router.push('/templates');
        }
        document.getElementsByTagName("html")[0].style.height = "100vh";
    },
    methods: {
        login: function login(_login, password) {
            var self = this;
            self.loginError = false;

            axios.post(this.$hostname + '/admin/auth', {
                login: _login,
                password: password
            }).then(function (response) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('role', response.data.role);
                localStorage.setItem('new-auth', "302");

                self.$router.push('/templates');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.loginError = true;

                // self.$notifications.notify(
                //     {
                //         component: notification,
                //         icon: 'nc-icon nc-simple-remove',
                //         horizontalAlign: 'right',
                //         verticalAlign: 'top',
                //         type: 'danger'
                //     })
            });
        }
    }
});

/***/ }),

/***/ "PbbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.getSubcategories()}]}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Подкатегория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.subcategory_id),expression:"model.subcategory_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "subcategory_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subcategories),function(s){return _c('option',{domProps:{"value":s.id}},[_vm._v(_vm._s(s.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Проект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.project_id),expression:"model.project_id"}],staticClass:"form-control",attrs:{"multiple":"","id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.projects),function(p){return _c('option',{domProps:{"value":p.id}},[_vm._v(_vm._s(p.name))])}),0)]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Описание","placeholder":""},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сумма","placeholder":""},model:{value:(_vm.model.amount),callback:function ($$v) {_vm.$set(_vm.model, "amount", $$v)},expression:"model.amount"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата","placeholder":""},model:{value:(_vm.model.date),callback:function ($$v) {_vm.$set(_vm.model, "date", $$v)},expression:"model.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.model.project_id || !_vm.model.amount || !_vm.model.category_id || !_vm.model.subcategory_id || !_vm.model.date},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pfth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'templates', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('c_status') ? localStorage.getItem('c_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('categories') < 1) {
            localStorage.setItem('c_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'card'
});

/***/ }),

/***/ "Qf8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'l-table',
    props: {
        columns: Array,
        data: Array
    },
    methods: {
        hasValue: function hasValue(item, column) {
            return item[column.toLowerCase()] !== 'undefined';
        },
        itemValue: function itemValue(item, column) {
            return item[column.toLowerCase()];
        }
    }
});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfc0341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("2zcV");
function injectStyle (ssrContext) {
  __webpack_require__("fPBy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cfc0341"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfc0341_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Scv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album.status),expression:"album.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.album, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.album.sort),callback:function ($$v) {_vm.$set(_vm.album, "sort", $$v)},expression:"album.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество треков в альбоме","placeholder":"","readonly":""},model:{value:(_vm.album.tracks_number),callback:function ($$v) {_vm.$set(_vm.album, "tracks_number", $$v)},expression:"album.tracks_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.album.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.album.image_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):(_vm.album.image_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.album.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.album.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.album.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.album)?_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SmHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Пуш-рассылки")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('pp_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("В процессе")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Отправлено")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Создать рассылку\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'id')?_c('span',[_vm._v("id")]):(column === 'project_id')?_c('span',[_vm._v("проект")]):(column === 'locale')?_c('span',[_vm._v("локали")]):(column === 'title')?_c('span',[_vm._v("тайтл")]):(column === 'text')?_c('span',[_vm._v("текст")]):(column === 'push_code')?_c('span',[_vm._v("код пуша")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'created_at')?_c('span',[_vm._v("дата создания")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === '')?_c('span',[_c('img',{staticClass:"remove-icon",attrs:{"src":"/static/img/delete.png"},on:{"click":function($event){return _vm.removeTask(item['id'])}}})]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"st text-warning"},[_vm._v("В процессе")]):_vm._e(),_vm._v(" "),(item[column] === 2)?_c('span',{staticClass:"st text-success"},[_vm._v("Отправлено")]):_vm._e()]):(column === 'project_id')?_c('span',[(item[column] === 9)?_c('span',{staticClass:"text-info"},[_vm._v("Muse")]):_vm._e()]):(column === 'created_at')?_c('span',[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                          ")]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__ = __webpack_require__("4pBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__ = __webpack_require__("+iwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__ = __webpack_require__("OprI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__ = __webpack_require__("ndI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Templates_vue__ = __webpack_require__("AtX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Template_Create_vue__ = __webpack_require__("x//Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Template_Edit_vue__ = __webpack_require__("DUIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Memories_vue__ = __webpack_require__("lnxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Memories_Create_vue__ = __webpack_require__("/8N7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Memories_Edit_vue__ = __webpack_require__("IZnu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Albums_vue__ = __webpack_require__("7mcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Albums_Create_vue__ = __webpack_require__("ZDeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Albums_Edit_vue__ = __webpack_require__("wR3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Tracks_vue__ = __webpack_require__("OrYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Tracks_Create_vue__ = __webpack_require__("NWP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Tracks_Edit_vue__ = __webpack_require__("lroX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Reports_vue__ = __webpack_require__("JniN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Reports_Create_vue__ = __webpack_require__("DuvD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Reports_Edit_vue__ = __webpack_require__("tuVN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Preview_vue__ = __webpack_require__("2R7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Icons_vue__ = __webpack_require__("U7xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Logs_vue__ = __webpack_require__("NAs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Finance_vue__ = __webpack_require__("P827");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Push_vue__ = __webpack_require__("okzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Push_Create_vue__ = __webpack_require__("eKw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Finance_Create_vue__ = __webpack_require__("hyCC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Finance_Edit_vue__ = __webpack_require__("PAcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Calendar_vue__ = __webpack_require__("nm/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__middleware_Auth__ = __webpack_require__("X1HV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__middleware_Viewer__ = __webpack_require__("WiDG");

// GeneralViews


// Admin pages































var routes = [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__["a" /* default */]
}, {
    path: '/',
    redirect: "/templates",
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
    children: [{
        path: 'categories',
        name: 'Categories',
        component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/create',
        name: 'create-category',
        component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/:id',
        name: 'edit-category',
        component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates',
        name: 'Templates',
        component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Templates_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_31__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'templates/create',
        name: 'create-template',
        component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Template_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates/:id',
        name: 'edit-template',
        component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Template_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'memories',
        name: 'Memories',
        component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Memories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_31__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'memories/create',
        name: 'create-for-you',
        component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Memories_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'memories/:id',
        name: 'edit-for-you',
        component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Memories_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates/create',
        name: 'create-template',
        component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Template_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'templates/:id',
        name: 'edit-template',
        component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Template_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'preview',
        name: 'Preview',
        component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Preview_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums',
        name: 'Albums',
        component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Albums_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums/create',
        name: 'create-album',
        component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Albums_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'albums/:id',
        name: 'edit-album',
        component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Albums_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks',
        name: 'Tracks',
        component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Tracks_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks/create',
        name: 'create-track',
        component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Tracks_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'tracks/:id',
        name: 'edit-track',
        component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Tracks_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'reports',
        name: 'reports',
        component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Reports_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'reports/create',
        name: 'create-report',
        component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Reports_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'reports/:id',
        name: 'edit-report',
        component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Reports_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance',
        name: 'finance',
        component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Finance_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'push-tasks',
        name: 'push-tasks',
        component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Push_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'push-tasks/create',
        name: 'create-push-tasks',
        component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Push_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance/create',
        name: 'create-finance',
        component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Finance_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'finance/:id',
        name: 'edit-finance',
        component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Finance_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_30__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'logs',
        name: 'logs',
        component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Logs_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_31__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'calendar',
        name: 'Calendar',
        component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Calendar_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_31__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'icons',
        name: 'Icons',
        component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Icons_vue__["a" /* default */]
        // meta: {
        //     middleware: [Auth]
        // },
    }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
        ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
        DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
        MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
    },
    data: function data() {
        return {
            role: parseInt(localStorage.getItem('role')) || 0
        };
    },

    methods: {
        toggleSidebar: function toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },

        resetOffsets: function resetOffsets() {
            localStorage.setItem('w_active_offset', 0);
        }
    }
});

/***/ }),

/***/ "TRiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            model: null,
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.getSettings();
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            if (!this.model.category_id) {
                return;
            }

            this.subcategories = this.categories.find(function (c) {
                return c.id === _this.model.category_id;
            }).subcategories;
        },

        getSettings: function getSettings() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/settings', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.settings));

                self.categories = data.categories;
                self.projects = data.projects;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
                self.model.project_id = JSON.parse(self.model.project_id);
                self.model.date = self.model.date.split('T')[0];

                self.getSubcategories();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/finance/' + this.id + '/update', model, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/finance');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }
    }
});

/***/ }),

/***/ "TiXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: {
                status: 0,
                templates: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/create', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "U6AA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n                        Выйти\n                    ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U72P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "U7xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("U72P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("EGO2");
function injectStyle (ssrContext) {
  __webpack_require__("ct9D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V19S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            columns: ['period', 'my_feed', 'muse', 'wallpapers', 'imagine', 'framy', 'marketing_spend', 'summary', ''],
            token: localStorage.getItem('token'),
            waiting: false,
            report: null,
            albums: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;
            this.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/reports/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.report = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.waiting = false;
            }).catch(function (error) {

                self.waiting = false;

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tracks/' + this.id + '/update', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                //  self.$router.push('/tracks');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration);

                    var minutes = Math.floor(data.duration / 60).toString();
                    var seconds = data.duration % 60 < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "VXPv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: {},
            model: {
                date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().utc().format('YYYY-MM-DD'),
                description: '',
                amount: '',
                category_id: 1,
                subcategory_id: 1,
                project_id: [1]
            },
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    created: function created() {
        this.getSettings();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            this.model.subcategory_id = 1;
            this.subcategories = this.categories.find(function (c) {
                return c.id === _this.model.category_id;
            }).subcategories;
        },

        getSettings: function getSettings() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/finance/settings', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.settings));

                self.categories = data.categories;
                self.projects = data.projects;

                self.getSubcategories();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/tracks/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(self.locales, function (l) {

                    var tModel = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/finance/create', model, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/finance');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        }
    }
});

/***/ }),

/***/ "Vcpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.category = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.category.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/' + this.id + '/update', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "Vg8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            columns: ['date', 'description', 'category_id', 'subcategory_id', 'project_id', 'amount', ''],
            data: [],
            summary: 0,
            type: "",
            start_date: localStorage.getItem('fi_date_start') ? localStorage.getItem('fi_date_start') : moment().startOf('month').format('YYYY-MM-DD'),
            end_date: localStorage.getItem('fi_date_end') ? localStorage.getItem('fi_date_end') : moment().utc().format('YYYY-MM-DD'),
            category_id: localStorage.getItem('fi_category') ? localStorage.getItem('fi_category') : "",
            subcategory_id: localStorage.getItem('fi_subcategory') ? localStorage.getItem('fi_subcategory') : "",
            project_id: [],
            loading: false,
            categories: [],
            subcategories: [],
            projects: []
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY');
            } else {
                return '';
            }
        },
        toMoneyFormat: function toMoneyFormat(value) {
            if (value) {
                return Intl.NumberFormat().format(value);
            } else {
                return '';
            }
        }
    },
    created: function created() {
        this.get();
    },
    methods: {
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/finance/create');
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-finance',
                params: { id: id }
            });
        },
        getSubcategories: function getSubcategories() {
            var _this = this;

            this.saveFilters('fi_category', this.category_id);

            if (this.category_id === "") {
                this.subcategory_id = "";
                return this.subcategories = [];
            }
            this.subcategory_id = "";
            this.subcategories = this.categories.find(function (c) {
                return c.id === parseInt(_this.category_id);
            }).subcategories;
        },

        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var dateStart = this.start_date === null ? '' : this.start_date;
            var dateEnd = this.end_date === null ? '' : this.end_date;

            this.loading = true;

            axios.get(this.$hostname + '/admin/finance/', {
                'params': {
                    date_start: dateStart,
                    date_end: dateEnd,
                    category_id: this.category_id,
                    subcategory_id: this.subcategory_id,
                    project_id: this.project_id
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.loading = false;

                self.data = response.data.finance;
                self.categories = response.data.settings.categories;
                self.projects = response.data.settings.projects;
                self.summary = response.data.summary;

                self.getSubcategories();
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('finance') < 1) {
            localStorage.setItem('fi_date_start', "");
            localStorage.setItem('fi_date_end', "");
            localStorage.setItem('fi_category', "");
            localStorage.setItem('fi_subcategory', "");
            localStorage.setItem('fi_project', "");
        }
        next();
    }
});

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "WiDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Viewer;
function Viewer(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth')) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "WrYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_premium),expression:"track.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_premium)?_vm._i(_vm.track.is_premium,null)>-1:(_vm.track.is_premium)},on:{"change":function($event){var $$a=_vm.track.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.is_trendy),expression:"track.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.track.is_trendy)?_vm._i(_vm.track.is_trendy,null)>-1:(_vm.track.is_trendy)},on:{"change":function($event){var $$a=_vm.track.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.track, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.track, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.track, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.album_id),expression:"track.album_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "album_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.albums),function(a){return (a.id !== 999)?_c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.track.status),expression:"track.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.track, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Артист","placeholder":""},model:{value:(_vm.track.artist),callback:function ($$v) {_vm.$set(_vm.track, "artist", $$v)},expression:"track.artist"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название","placeholder":""},model:{value:(_vm.track.title),callback:function ($$v) {_vm.$set(_vm.track, "title", $$v)},expression:"track.title"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Длительность","readonly":"","placeholder":""},model:{value:(_vm.track.duration),callback:function ($$v) {_vm.$set(_vm.track, "duration", $$v)},expression:"track.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.track.sort),callback:function ($$v) {_vm.$set(_vm.track, "sort", $$v)},expression:"track.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Фон: "),(_vm.track.image_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.image_src_size >= 0.3)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):(_vm.track.image_src_size >= 0.2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.image_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.image_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"imageFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'image_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.imageFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.track.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.track.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):(_vm.track.src_size >= 2)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.track.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.track.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.track.album_id || !_vm.track.sort || !_vm.track.title || !_vm.track.artist || !_vm.track.src},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X1HV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Auth;
function Auth(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth')) {
        return router.push({ name: 'login' });
    }

    var role = localStorage.getItem('role');
    if (!role || role != 1) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "Xnfv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xwwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Название шаблона","placeholder":""},model:{value:(_vm.template.name),callback:function ($$v) {_vm.$set(_vm.template, "name", $$v)},expression:"template.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"type-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._v("\n                                        Обновила в таблице название типов.\n\n                                        Обсудили, что в версии 5.5 будем реализовывать возможность в админке выставлять приоритет фото/видео.\n\n                                        Типы Spring Camera Roll, Spring Recap можно будет заменить уже существующим типом По дате: Весна.\n\n                                        Типы One day of my life, Day of my life with date заменяются одним типом По дате: рандомный день.\n\n                                        Тип Recently переименовываем в тип По дате: последние 30 дней.\n\n                                        "),_c('option',{attrs:{"value":"1"}},[_vm._v("1. По дате: прошлая неделя")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2. По дате: прошлый месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3. По дате: текущий месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4. По дате: прошлый год")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5. По дате: текущий год")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6. По дате: прошлые выходные")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7. По дате: будние дни на прошлой неделе")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("8. По дате: Лето")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("9. По дате: Осень")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10. По дате: Зима")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11. По дате: Весна")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12. По дате: Лето прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13. По дате: Осень прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14. По дате: Зима прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15. По дате: Весна прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16. По местоположению: Путешествие")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17. По местоположению: Дом")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18. One day of my life")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19. Recently")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20. Day of my life with date")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21. Spring Camera Roll")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22. Spring  Recap")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23. По дате: за последние 6 месяцев")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"2.1"}},[_vm._v("2.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.2"}},[_vm._v("2.2")]),_vm._v(" "),_c('option',{attrs:{"value":"2.7"}},[_vm._v("2.7")]),_vm._v(" "),_c('option',{attrs:{"value":"2.8"}},[_vm._v("2.8")]),_vm._v(" "),_c('option',{attrs:{"value":"2.9"}},[_vm._v("2.9")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.1"}},[_vm._v("3.1")]),_vm._v(" "),_c('option',{attrs:{"value":"3.2"}},[_vm._v("3.2")]),_vm._v(" "),_c('option',{attrs:{"value":"3.3"}},[_vm._v("3.3")]),_vm._v(" "),_c('option',{attrs:{"value":"3.4"}},[_vm._v("3.4")]),_vm._v(" "),_c('option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('option',{attrs:{"value":"3.6"}},[_vm._v("3.6")]),_vm._v(" "),_c('option',{attrs:{"value":"3.7"}},[_vm._v("3.7")]),_vm._v(" "),_c('option',{attrs:{"value":"3.8"}},[_vm._v("3.8")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("4.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.1"}},[_vm._v("4.1")]),_vm._v(" "),_c('option',{attrs:{"value":"4.2"}},[_vm._v("4.2")]),_vm._v(" "),_c('option',{attrs:{"value":"4.3"}},[_vm._v("4.3")]),_vm._v(" "),_c('option',{attrs:{"value":"4.4"}},[_vm._v("4.4")]),_vm._v(" "),_c('option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('option',{attrs:{"value":"4.6"}},[_vm._v("4.6")]),_vm._v(" "),_c('option',{attrs:{"value":"5.0"}},[_vm._v("5.0")]),_vm._v(" "),_c('option',{attrs:{"value":"5.1"}},[_vm._v("5.1")]),_vm._v(" "),_c('option',{attrs:{"value":"5.2"}},[_vm._v("5.2")]),_vm._v(" "),_c('option',{attrs:{"value":"5.3"}},[_vm._v("5.3")]),_vm._v(" "),_c('option',{attrs:{"value":"5.4"}},[_vm._v("5.4")]),_vm._v(" "),_c('option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('option',{attrs:{"value":"5.6"}},[_vm._v("5.6")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип публикации")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.push_type),expression:"template.push_type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "push_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Стандартный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Доступен через час + пуш с превью")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                        текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Видео: "),(_vm.template.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.template.audio)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.videos || !_vm.template.type || !_vm.template.name
                                    || !_vm.template.song || !_vm.template.audio || !_vm.template.preview_src
                                    || (_vm.template.is_copyrighted === true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.is_text_active)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                        Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                            "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (t.id))}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                            Копировать\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                        ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.category === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.category)}}},[_vm._v("\n                                            "+_vm._s(t.category === 'styled_shapes' ? 'Style shapes' : t.category)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('div',_vm._l((t.files),function(c,index){return (t.category === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (c.id))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                        "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration)+" сек")])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":("static/objects/" + (_vm.template.objects[_vm.active_object].category) + "/" + (_vm.template.objects[_vm.active_object].id))},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0),expression:"template.objects[active_object].id.indexOf('nocolor') < 0"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{attrs:{"id":"preview-container"}},[_c('div',{attrs:{"id":"player"}},[_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.preview_src_full}})]),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                        Показать превью\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),(_vm.template.videos)?_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты "),_c('br'),_vm._v("\n                                    (длительность:\n                                    "),(Math.abs(_vm.sumParts - _vm.template.duration) > 0.05)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))]),_vm._v("):\n                                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return (_vm.template.videos)?_c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"#" + String(index + 1) + " - длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),(_vm.client_parts[index].effect_type !== 0 && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                    'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])]):_vm._e()})],2)])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YEKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.category_id),expression:"template.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return (c.id !== 999)?_c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"2.1"}},[_vm._v("2.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.2"}},[_vm._v("2.2")]),_vm._v(" "),_c('option',{attrs:{"value":"2.7"}},[_vm._v("2.7")]),_vm._v(" "),_c('option',{attrs:{"value":"2.8"}},[_vm._v("2.8")]),_vm._v(" "),_c('option',{attrs:{"value":"2.9"}},[_vm._v("2.9")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.1"}},[_vm._v("3.1")]),_vm._v(" "),_c('option',{attrs:{"value":"3.2"}},[_vm._v("3.2")]),_vm._v(" "),_c('option',{attrs:{"value":"3.3"}},[_vm._v("3.3")]),_vm._v(" "),_c('option',{attrs:{"value":"3.4"}},[_vm._v("3.4")]),_vm._v(" "),_c('option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('option',{attrs:{"value":"3.6"}},[_vm._v("3.6")]),_vm._v(" "),_c('option',{attrs:{"value":"3.7"}},[_vm._v("3.7")]),_vm._v(" "),_c('option',{attrs:{"value":"3.8"}},[_vm._v("3.8")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("4.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.1"}},[_vm._v("4.1")]),_vm._v(" "),_c('option',{attrs:{"value":"4.2"}},[_vm._v("4.2")]),_vm._v(" "),_c('option',{attrs:{"value":"4.3"}},[_vm._v("4.3")]),_vm._v(" "),_c('option',{attrs:{"value":"4.4"}},[_vm._v("4.4")]),_vm._v(" "),_c('option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('option',{attrs:{"value":"4.6"}},[_vm._v("4.6")]),_vm._v(" "),_c('option',{attrs:{"value":"5.0"}},[_vm._v("5.0")]),_vm._v(" "),_c('option',{attrs:{"value":"5.1"}},[_vm._v("5.1")]),_vm._v(" "),_c('option',{attrs:{"value":"5.2"}},[_vm._v("5.2")]),_vm._v(" "),_c('option',{attrs:{"value":"5.3"}},[_vm._v("5.3")]),_vm._v(" "),_c('option',{attrs:{"value":"5.4"}},[_vm._v("5.4")]),_vm._v(" "),_c('option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('option',{attrs:{"value":"5.6"}},[_vm._v("5.6")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trendy-control"}},[_vm._v("Популярное")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trendy),expression:"template.is_trendy"}],staticClass:"form-check-inline",attrs:{"id":"trendy-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trendy)?_vm._i(_vm.template.is_trendy,null)>-1:(_vm.template.is_trendy)},on:{"change":function($event){var $$a=_vm.template.is_trendy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trendy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trendy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trendy", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"trending-music-control"}},[_vm._v("Трендовая музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_trending_music),expression:"template.is_trending_music"}],staticClass:"form-check-inline",attrs:{"id":"trending-music-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_trending_music)?_vm._i(_vm.template.is_trending_music,null)>-1:(_vm.template.is_trending_music)},on:{"change":function($event){var $$a=_vm.template.is_trending_music,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_trending_music", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_trending_music", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_trending_music", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                        текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"disabled":!_vm.template.src_full || !_vm.template.preview_src_full,"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Видео: "),(_vm.template.src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.src_size >= 4)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):(_vm.template.src_size >= 3)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"videoFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.videoFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Превью: "),(_vm.template.preview_src)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.template.audio)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.duration || !_vm.template.videos || !_vm.template.category_id || !_vm.template.song || !_vm.template.src || !_vm.template.preview_src || !_vm.template.audio
                                    || (_vm.template.is_copyrighted == true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),(_vm.is_text_active)?_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                        Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                            "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (t.id))}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                            Копировать\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                        ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.category === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.category)}}},[_vm._v("\n                                            "+_vm._s(t.category === 'styled_shapes' ? 'Style shapes' : t.category)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('div',_vm._l((t.files),function(c,index){return (t.category === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (c.id))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                        "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":("static/objects/" + (_vm.template.objects[_vm.active_object].category) + "/" + (_vm.template.objects[_vm.active_object].id))},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0),expression:"template.objects[active_object].id.indexOf('nocolor') < 0"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template.src_full)?_c('div',{attrs:{"id":"preview-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.src_full),expression:"template.src_full"}],attrs:{"id":"player"}},[(!_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player","poster":_vm.template.preview_src_full},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),(_vm.isVideo(_vm.template.preview_src_full))?_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player2"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.src_full}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                        Показать превью\n                                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),(_vm.template.videos)?_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты:\n                                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return (_vm.template.videos)?_c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"#" + String(index + 1) + " - длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row bordered"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Коллаж")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].collage_type),expression:"client_parts[index].collage_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "collage_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeCollageType(index, _vm.client_parts[index].collage_type)}]}},_vm._l((_vm.collage_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])]),_vm._v(" "),(_vm.client_parts[index].collage_type)?_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Время начала","placeholder":""},on:{"input":function($event){return _vm.formatStartTime($event, index)}},model:{value:(_vm.client_parts[index].start_time),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "start_time", $$v)},expression:"client_parts[index].start_time"}})],1):_vm._e()]),_vm._v(" "),(_vm.client_parts[index].effect_type !== 0 && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                    'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])]):_vm._e()})],2)])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YbGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            album: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album = data.album;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.album.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var album = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.album));

            album.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/albums/' + this.id + '/update', album, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0410\u043B\u044C\u0431\u043E\u043C \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/albums');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.album.image_src = data.url;
                self.album.image_src_full = data.url_full;
                self.album.image_src_size = data.filesize;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "YyF9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("+YzX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e9a4e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Scv/");
function injectStyle (ssrContext) {
  __webpack_require__("Mt/T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70e9a4e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e9a4e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("MFnH");
function injectStyle (ssrContext) {
  __webpack_require__("rkeS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73211b65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("kgzt");
function injectStyle (ssrContext) {
  __webpack_require__("vqQU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v("\n                        - Новый отчет")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8 buttons-block"},[_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Отчет все страны и регионы (один файл, txt): "),(_vm.data.reports_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.data.reports_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"reportsFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'reports_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.reportsFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Отчет Бразилия (txt): "),(_vm.data.reportsBRL_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.data.reportsBRL_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"reportsBRLFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'reportsBRL_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.reportsBRLFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Курсы валют (csv): "),(_vm.data.rates_src)?_c('span',[_c('span',{staticClass:"inline-link"},[_c('a',{attrs:{"href":_vm.data.rates_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"ratesFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'rates_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.ratesFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),(_vm.data.revenue > 0)?_c('div',{staticClass:"col-md-4"},[_c('div',[_vm._v("My Feed: "+_vm._s(_vm.data.revenue_0)+" $")]),_vm._v(" "),_c('div',[_vm._v("Muse: "+_vm._s(_vm.data.revenue_1)+" $")]),_vm._v(" "),_c('div',[_vm._v("Wallpapers: "+_vm._s(_vm.data.revenue_2)+" $")]),_vm._v(" "),_c('div',[_vm._v("Imagine: "+_vm._s(_vm.data.revenue_3)+" $")]),_vm._v(" "),_c('div',[_vm._v("Framy: "+_vm._s(_vm.data.revenue_4)+" $")]),_vm._v(" "),_c('div',[_vm._v("---")]),_vm._v(" "),_c('div',[_vm._v("Общий доход: "+_vm._s(_vm.data.revenue)+" $")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.data.reports_src || !_vm.data.rates_src},on:{"click":function($event){$event.preventDefault();return _vm.upload.apply(null, arguments)}}},[_vm._v("\n                                Загрузить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "blLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            track: {
                status: 0,
                src: null,
                src_full: null,
                image_src: null,
                image_src_full: null,
                sort: 1,
                artist: null,
                title: null,
                duration: null,
                album_id: null,
                is_premium: 1,
                is_trendy: 0
            },
            albums: []
        };
    },

    created: function created() {
        this.getAlbums();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getAlbums: function getAlbums() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var track = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.track));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/tracks/create', track, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0422\u0440\u0435\u043A \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/tracks');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            var needID3 = type === 'src';

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type,
                    needID3: needID3
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.track[data.file_type] = data.url;
                self.track[data.file_type + '_full'] = data.url_full;
                self.track[data.file_type + '_size'] = data.filesize;

                if (needID3 && data.duration) {
                    data.duration = Math.floor(data.duration);

                    var minutes = Math.floor(data.duration / 60).toString();
                    var seconds = data.duration % 60 < 10 ? '0' + (data.duration % 60).toString() : (data.duration % 60).toString();
                    self.track.duration = minutes + ':' + seconds;
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("KGJ+");
function injectStyle (ssrContext) {
  __webpack_require__("IRFK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ct9D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dePQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.getAlbums();
    },
    data: function data() {
        return {
            columns: ['id', 'album', 'src_full', 'image_src_full', 'artist', 'title', 'sort', 'status', ''],
            data: [],
            albums: [],
            album: localStorage.getItem('t_album') ? localStorage.getItem('t_album') : "",
            status: localStorage.getItem('t_status') ? localStorage.getItem('t_status') : "",
            loading: false,
            limit: 10,
            tracksCount: 0,
            offset: parseInt(localStorage.getItem('t_active_offset')) || 0,
            stats: {
                freeTracksCount: 0,
                premiumTracksCount: 0,
                averageTracksCount: 0,
                averageFreeCount: 0,
                averagePremiumCount: 0
            }
        };
    },

    filters: {
        secondsToTime: function secondsToTime(value) {
            if (value) {
                return Math.floor(value / 60).toString() + ':' + (value % 60).toString();
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {},
        filter: function filter() {
            localStorage.setItem('t_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function add() {
            this.$router.push('/tracks/create');
        },
        getAlbums: function getAlbums() {
            var self = this;

            var token = localStorage.getItem('token');

            axios.get(this.$hostname + '/admin/albums', {
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.albums = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.get();
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/tracks/', {
                'params': {
                    status: this.status,
                    album: this.album,
                    limit: this.limit,
                    offset: this.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                var data = response.data;
                self.loading = false;

                self.data = data.tracks;
                self.tracksCount = data.count;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('t_active_offset', parseInt(this.offset));
            }
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-track',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('tracks') < 1) {
            localStorage.setItem('t_active_offset', "0");
            localStorage.setItem('t_album', "");
            localStorage.setItem('t_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "e3EN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eApH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bc1c1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("kb8s");
function injectStyle (ssrContext) {
  __webpack_require__("tmV1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bc1c1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eKw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("rVgw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292edd6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("Ga2a");
function injectStyle (ssrContext) {
  __webpack_require__("/Z3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-292edd6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292edd6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    name: 'fg-input',
    props: {
        label: String,
        value: [String, Number],
        addonRightIcon: String,
        addonLeftIcon: String
    },
    computed: {
        hasIcon: function hasIcon() {
            var _$slots = this.$slots,
                addonRight = _$slots.addonRight,
                addonLeft = _$slots.addonLeft;

            return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
        }
    }
});

/***/ }),

/***/ "fPBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gRil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Memories")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Copyrighted")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCopyrighted),expression:"isCopyrighted"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isCopyrighted=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_is_copyrighted', _vm.isCopyrighted)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Free")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Copyrighted")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("New")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.isNew),expression:"isNew"}],staticClass:"form-control",attrs:{"id":"trendy-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.isNew=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ctt_is_new', _vm.isNew)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("New")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),(_vm.role < 2)?_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить шаблон\n                                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'preview_src_full')?_c('span',[_vm._v("превью")]):(column === 'counter')?_c('span',[_vm._v("экспорт")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'push_type')?_c('span',[_vm._v("тип")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'videos')?_c('span',[_vm._v("количество видео")]):(column === 'duration')?_c('span',[_vm._v("длительность, сек.")]):(column === 'release_date')?_c('span',[_vm._v("дата публикации")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_trendy')?_c('span',[_vm._v("популярное")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'preview_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(!_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(_vm.isVideo(item[column]))?_c('div',{staticClass:"device-block device1"},[_c('video',{key:item[column],staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"muted":"","loop":"","autoplay":"","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":item[column]}})])]):_vm._e()]):(column === 'color'  && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'color_group' && item[column])?_c('span',{staticClass:"color-block",style:({ backgroundColor: '#' + item[column] })}):(column === 'name')?_c('span',[(_vm.role < 2)?_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))]):_vm._e()]):(column === '')?_c('span',[(_vm.role < 2)?_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")]):_vm._e()]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Опубликовано")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Ожидает")]):_vm._e()]):(column === 'push_type')?_c('span',[(item[column] !== 0)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/push.png"}}):_vm._e()]):(column === 'release_date')?_c('span',{},[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'duration')?_c('span',{},[_c('span',{class:{ 'bg-danger' : _vm.isWrongDuration(item) }},[_vm._v(_vm._s(item[column]))])]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === 'type')?_c('span',[(item[column] === 2)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/live.png"}}):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gTbC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h4pk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hszI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('c_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'templates')?_c('span',[_vm._v("количество шаблонов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hyCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("VXPv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ec9782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("PbbT");
function injectStyle (ssrContext) {
  __webpack_require__("yYsp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7ec9782"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ec9782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("u6Ka");
function injectStyle (ssrContext) {
  __webpack_require__("YyF9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kP44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            lock_waiting: false,
            interval: null,
            is_playing: false,
            show_svg_modal: false,
            is_object_changing: false,
            video: null,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            active_object_category: 'arrows',
            template: {
                status: 0,
                category_id: null,
                sort: 1,
                videos: null,
                duration: null,
                v: "",
                src: null,
                src_full: null,
                src_size: null,
                preview_src: null,
                preview_src_full: null,
                preview_src_size: null,
                audio: null,
                audio_full: null,
                audio_size: null,
                song: null,
                song_insta: "",
                song_tiktok: "",
                release_date: null,
                release_time: '12:00',
                is_premium: 0,
                is_trendy: 0,
                is_trending_music: 0,
                is_copyrighted: 0,
                is_new: 0,
                parts: [],
                texts: [],
                objects: []
            },
            categories: [],
            client_parts: [],
            is_text_active: false,
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0
            },
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }, {
                params: "'Amsterdam Four', sans-serif;",
                code: "Amsterdam Four",
                name: "Amsterdam Four"
            }, {
                params: "'Bodoni 72', sans-serif;",
                code: "Bodoni 72",
                name: "Bodoni 72"
            }, {
                params: "'Courier New', sans-serif;",
                code: "Courier New",
                name: "Courier New"
            }, {
                params: "'Didot', sans-serif;",
                code: "Didot",
                name: "Didot"
            }, {
                params: "'Menlo', sans-serif;",
                code: "Menlo",
                name: "Menlo"
            }, {
                params: "'Optima', sans-serif;",
                code: "Optima",
                name: "Optima"
            }, {
                params: "'Copperplate Gothic Light', sans-serif;",
                code: "Copperplate Gothic Light",
                name: "Copperplate"
            }, {
                params: "'Avenir', sans-serif;",
                code: "Avenir",
                name: "Avenir"
            }, {
                params: "'AmaticSC-Bold', sans-serif;",
                code: "AmaticSC-Bold",
                name: "Amatic SC"
            }, {
                params: "'Zapfino', sans-serif;",
                code: "Zapfino",
                name: "Zapfino"
            }, {
                params: "'BebasNeue-Regular', sans-serif;",
                code: "BebasNeue-Regular",
                name: "Bebas Neue"
            }, {
                params: "'Noteworthy', sans-serif;",
                code: "Noteworthy",
                name: "Noteworthy"
            }, {
                params: "'DancingScript-Bold', sans-serif;",
                code: "DancingScript-Bold",
                name: "Dancing Script"
            }, {
                params: "'Chilanka-Regular', sans-serif;",
                code: "Chilanka-Regular",
                name: "Chilanka"
            }, {
                params: "'Intro', sans-serif;",
                code: "Intro",
                name: "Intro"
            }, {
                params: "'Futura', sans-serif;",
                code: "Futura",
                name: "Futura"
            }, {
                params: "'JosefinSans-Bold', sans-serif;",
                code: "JosefinSans-Bold",
                name: "Josefin Sans"
            }, {
                params: "'Kalam-Bold', sans-serif;",
                code: "Kalam-Bold",
                name: "Kalam"
            }, {
                params: "'Lato-Regular', sans-serif;",
                code: "Lato-Regular",
                name: "Lato"
            }, {
                params: "'Lobster-Regular', sans-serif;",
                code: "Lobster-Regular",
                name: "Lobster"
            }, {
                params: "'Raleway-Bold', sans-serif;",
                code: "Raleway-Bold",
                name: "Raleway"
            }, {
                params: "'Bentoga', sans-serif;",
                code: "Bentoga-Thin",
                name: "Bentoga"
            }, {
                params: "'Brusher', sans-serif;",
                code: "Brusher",
                name: "Brusher"
            }, {
                params: "'Calistoga', sans-serif;",
                code: "Calistoga-Regular",
                name: "Calistoga"
            }, {
                params: "'Fondamento', sans-serif;",
                code: "Fondamento-Regular",
                name: "Fondamento"
            }, {
                params: "'Savoye LET', sans-serif;",
                code: "Savoye LET",
                name: "Savoye LET"
            }, {
                params: "'Homemade Apple', sans-serif;",
                code: "HomemadeApple-Regular",
                name: "Homemade Apple"
            }, {
                params: "'Luna', sans-serif;",
                code: "Luna",
                name: "Luna"
            }, {
                params: "'NewYork', sans-serif;",
                code: "NewYork",
                name: "NewYork"
            }, {
                params: "'Pathway Gothic', sans-serif;",
                code: "PathwayGothicOne-Regular",
                name: "Pathway Gothic"
            }, {
                params: "'Quattrocento', sans-serif;",
                code: "Quattrocento-Bold",
                name: "Quattrocento"
            }, {
                params: "'Syne', sans-serif;",
                code: "Syne-Bold",
                name: "Syne"
            }, {
                params: "'Thesignature', sans-serif;",
                code: "Thesignature",
                name: "Thesignature"
            }, {
                params: "'Tuesday Night', sans-serif;",
                code: "TuesdayNight-Regular",
                name: "Tuesday Night"
            }, {
                params: "'Yellowtail', sans-serif;",
                code: "Yellowtail-Regular",
                name: "Yellowtail"
            }, {
                params: "'Aegean', sans-serif;",
                code: "Aegean",
                name: "Aegean"
            }, {
                params: "'ALTA', sans-serif;",
                code: "Alta_regular",
                name: "ALTA"
            }, {
                params: "'Baskerville', sans-serif;",
                code: "Baskerville",
                name: "Baskerville"
            }, {
                params: "'Belleza', sans-serif;",
                code: "Belleza",
                name: "Belleza"
            }, {
                params: "'Black Mango', sans-serif;",
                code: "Black Mango",
                name: "Black Mango"
            }, {
                params: "'Catchy Mager', sans-serif;",
                code: "Catchy Mager",
                name: "Catchy Mager"
            }, {
                params: "'Hatton', sans-serif;",
                code: "Hatton",
                name: "Hatton"
            }, {
                params: "'HUOVA', sans-serif;",
                code: "HUOVA",
                name: "HUOVA"
            }, {
                params: "'Kudryashev', sans-serif;",
                code: "Kudryashev",
                name: "Kudryashev"
            }, {
                params: "'Laguna', sans-serif;",
                code: "Laguna",
                name: "Laguna"
            }, {
                params: "'Liana', sans-serif;",
                code: "Liana",
                name: "Liana"
            }, {
                params: "'Lovelace', sans-serif;",
                code: "Lovelace",
                name: "Lovelace"
            }, {
                params: "'Lovelo', sans-serif;",
                code: "Lovelo",
                name: "Lovelo"
            }, {
                params: "'Mak', sans-serif;",
                code: "Mak",
                name: "Mak"
            }, {
                params: "'Maragsa', sans-serif;",
                code: "Maragsa",
                name: "Maragsa"
            }, {
                params: "'Tan Pearl', sans-serif;",
                code: "Tan Pearl",
                name: "Tan Pearl"
            }, {
                params: "'Tenor', sans-serif;",
                code: "Tenor",
                name: "Tenor"
            }, {
                params: "'The Seasons', sans-serif;",
                code: "The Seasons",
                name: "The Seasons"
            }, {
                params: "'Allura', sans-serif;",
                code: "Allura",
                name: "Allura"
            }, {
                params: "'Alyssum', sans-serif;",
                code: "Alyssum",
                name: "Alyssum"
            }, {
                params: "'Bangers', sans-serif;",
                code: "Bangers",
                name: "Bangers"
            }, {
                params: "'Boulder', sans-serif;",
                code: "Boulder",
                name: "Boulder"
            }, {
                params: "'Carlson', sans-serif;",
                code: "Carlson",
                name: "Carlson"
            }, {
                params: "'Hello January', sans-serif;",
                code: "Hello January",
                name: "Hello January"
            }, {
                params: "'Hit and Run', sans-serif;",
                code: "Hit and Run",
                name: "Hit and Run"
            }, {
                params: "'Horta', sans-serif;",
                code: "Horta",
                name: "Horta"
            }, {
                params: "'Knewave', sans-serif;",
                code: "Knewave",
                name: "Knewave"
            }, {
                params: "'Lovelies', sans-serif;",
                code: "Lovelies",
                name: "Lovelies"
            }, {
                params: "'Monoton', sans-serif;",
                code: "Monoton",
                name: "Monoton"
            }, {
                params: "'Party Confetti', sans-serif;",
                code: "Party Confetti",
                name: "Party Confetti"
            }, {
                params: "'Peace', sans-serif;",
                code: "Peace",
                name: "Peace"
            }, {
                params: "'Petit Cochon', sans-serif;",
                code: "Petit Cochon",
                name: "Petit Cochon"
            }, {
                params: "'Playlist', sans-serif;",
                code: "Playlist",
                name: "Playlist"
            }, {
                params: "'Pushkin', sans-serif;",
                code: "Pushkin",
                name: "Pushkin"
            }, {
                params: "'Sarina', sans-serif;",
                code: "Sarina",
                name: "Sarina"
            }, {
                params: "'Shrikhand', sans-serif;",
                code: "Shrikhand",
                name: "Shrikhand"
            }, {
                params: "'Studly', sans-serif;",
                code: "Studly",
                name: "Studly"
            }, {
                params: "'The Youngest', sans-serif;",
                code: "The Youngest",
                name: "The Youngest"
            }, {
                params: "'Amsterdam One', sans-serif;",
                code: "Amsterdam One",
                name: "Amsterdam One"
            }, {
                params: "'Brittany', sans-serif;",
                code: "Brittany",
                name: "Brittany"
            }, {
                params: "'Daydream', sans-serif;",
                code: "Daydream",
                name: "Daydream"
            }, {
                params: "'Inters', sans-serif;",
                code: "Inters",
                name: "Inters"
            }, {
                params: "'Kavivanar', sans-serif;",
                code: "Kavivanar",
                name: "Kavivanar"
            }, {
                params: "'Mixa', sans-serif;",
                code: "Mixa",
                name: "Mixa"
            }, {
                params: "'Sisterhood', sans-serif;",
                code: "Sisterhood",
                name: "Sisterhood"
            }, {
                params: "'Virtual', sans-serif;",
                code: "Virtual",
                name: "Virtual"
            }, {
                params: "'Anton', sans-serif;",
                code: "Anton",
                name: "Anton"
            }, {
                params: "'Blue-Ocean', sans-serif;",
                code: "Blue Ocean",
                name: "Blue Ocean"
            }, {
                params: "'Cormorant', sans-serif;",
                code: "Cormorant",
                name: "Cormorant"
            }, {
                params: "'Culture', sans-serif;",
                code: "Culture",
                name: "Culture"
            }, {
                params: "'Keep-on-Truckin', sans-serif;",
                code: "Keep on Truckin",
                name: "Keep on Truckin"
            }, {
                params: "'Kingthings', sans-serif;",
                code: "Kingthings",
                name: "Kingthings"
            }, {
                params: "'Maharlika', sans-serif;",
                code: "Maharlika",
                name: "Maharlika"
            }, {
                params: "'Montserrat', sans-serif;",
                code: "Montserrat",
                name: "Montserrat"
            }, {
                params: "'Nectarine', sans-serif;",
                code: "Nectarine",
                name: "Nectarine"
            }, {
                params: "'Sandy', sans-serif;",
                code: "Sandy",
                name: "Sandy"
            }, {
                params: "'Tan-Paradiso', sans-serif;",
                code: "Tan-Paradiso",
                name: "Tan-Paradiso"
            }, {
                params: "'Well-Cake', sans-serif;",
                code: "Well-Cake",
                name: "Well-Cake"
            }, {
                params: "'Agrandir', sans-serif;",
                code: "Agrandir",
                name: "Agrandir"
            }, {
                params: "'BlackGold', sans-serif;",
                code: "BlackGold",
                name: "BlackGold"
            }, {
                params: "'Bright', sans-serif;",
                code: "Bright",
                name: "Bright"
            }, {
                params: "'Brown Sugar', sans-serif;",
                code: "Brown Sugar",
                name: "Brown Sugar"
            }, {
                params: "'Garet', sans-serif;",
                code: "Garet",
                name: "Garet"
            }, {
                params: "'Harmony', sans-serif;",
                code: "Harmony",
                name: "Harmony"
            }, {
                params: "'Migra', sans-serif;",
                code: "Migra",
                name: "Migra"
            }, {
                params: "'Migra Italic', sans-serif;",
                code: "Migra Italic",
                name: "Migra Italic"
            }, {
                params: "'Noto Serif Display', sans-serif;",
                code: "Noto Serif Display",
                name: "Noto Serif Display"
            }, {
                params: "'Pinyon Script', sans-serif;",
                code: "Pinyon Script",
                name: "Pinyon Script"
            }, {
                params: "'Sloop Script', sans-serif;",
                code: "Sloop Script",
                name: "Sloop Script"
            }, {
                params: "'Redkits', sans-serif;",
                code: "Redkits",
                name: "Redkits"
            }, {
                params: "'Sceageus', sans-serif;",
                code: "Sceageus",
                name: "Sceageus"
            }, {
                params: "'Tan Nimbus', sans-serif;",
                code: "Tan Nimbus",
                name: "Tan Nimbus"
            }, {
                params: "'Kenao', sans-serif;",
                code: "Kenao",
                name: "Kenao"
            }],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            animation_types: [{
                id: 0,
                name: "Без анимации"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Scale"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            collage_types: [{
                id: 0,
                name: "-",
                params: null
            }, {
                id: 1,
                name: "1/4",
                params: { x: 0, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 2,
                name: "2/4",
                params: { x: 0.5, y: 0, w: 0.5, h: 0.5 }
            }, {
                id: 3,
                name: "3/4",
                params: { x: 0, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 4,
                name: "4/4",
                params: { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
            }, {
                id: 5,
                name: "1/3",
                params: { x: 0, y: 0, w: 1, h: 0.3333 }
            }, {
                id: 6,
                name: "2/3",
                params: { x: 0, y: 0.3333, w: 1, h: 0.3333 }
            }, {
                id: 7,
                name: "3/3",
                params: { x: 0, y: 0.6666, w: 1, h: 0.3333 }
            }, {
                id: 8,
                name: "1/2",
                params: { x: 0, y: 0, w: 1, h: 0.5 }
            }, {
                id: 9,
                name: "2/2",
                params: { x: 0, y: 0.5, w: 1, h: 0.5 }
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: []
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {

        var self = this;

        self.waiting = true;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + self.token
            }
        }).then(function (response) {
            self.waiting = false;
            self.categories = response.data;

            // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
            var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            var open = indexedDB.open("MuseDatabase");

            open.onupgradeneeded = function () {
                var db = open.result;
                var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
            };

            open.onsuccess = function () {
                // Start a new transaction
                var db = open.result;
                var tx = db.transaction("MuseObjectStore", "readwrite");
                var store = tx.objectStore("MuseObjectStore");
                var data = store.get(self.$storeVersion);

                data.onsuccess = function () {
                    console.log(data.result);
                    if (!data.result) {
                        self.getSVG();
                    } else {
                        self.svg_list = data.result.object;
                    }
                };

                // Close the db when the transaction is done
                tx.oncomplete = function () {
                    db.close();
                };
            };

            open.onerror = function (error) {
                console.log(error);
            };
        }).catch(function (error) {
            self.waiting = false;
            console.log(error);
        });
    },
    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.client_parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(this.fonts, function (f) {
                return f.name;
            });
        }
    },
    methods: {
        text_html: function text_html(index) {

            var textModel = this.template.texts[index];

            var text = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction == 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source) {
                return "";
            }

            var source = objectModel.source;

            var width = 100;
            var height = 100;
            var w = source.match(/width="\d{1,5}"/);
            var h = source.match(/height="\d{1,5}"/);
            if (w && h) {
                width = w[0].split('"')[1];
                height = h[0].split('"')[1];
            }

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            source = source.replace(/width="\d{1,4}"/, 'width="' + width + '"');
            source = source.replace(/height="\d{1,4}"/, 'height="' + height + '"');
            source = source.replace(/fill="black"/g, 'fill="' + objectModel.color + '"');
            source = source.replace(/stroke="black"/g, 'stroke="' + objectModel.color + '"');

            var style = ' style="opacity: ' + objectModel.alpha + '; border: 1px solid white; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '"';

            source = this.insertAt(source, style, 5);

            return source;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatStartTime: function formatStartTime(event, index) {
            this.client_parts[index].start_time = this.client_parts[index].start_time.replace(',', '.');
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {

                if (self.is_object_changing) {
                    var obj = self.template.objects[self.active_object];
                    obj.id = object.id;
                    obj.source = object.source;
                    obj.category = object.category;
                } else {
                    var newObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_object));
                    newObj.id = object.id;
                    newObj.source = object.source;
                    newObj.category = object.category;
                    self.template.objects.push(newObj);
                    self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }

                self.is_object_changing = false;
                self.show_svg_modal = false;
            }

            self.active_object_category = 'arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                    self.video = self.$refs.videoContainer;

                    self.video.addEventListener("playing", function () {
                        console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeCollageType: function changeCollageType(index, type) {

            if (type === 0) {
                this.client_parts[index].frame = null;
                return;
            }

            this.client_parts[index].frame = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.collage_types, function (c) {
                return c.id === type;
            }).params;
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    effect_values: { x: 0.5, y: 0.5 },
                    collage_type: 0,
                    frame: 0,
                    start_time: 0
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
            }, 30);
        },
        goBack: function goBack() {
            window.history.back();
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'arrows';
            }
        },
        getSVG: function getSVG() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var self;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;


                                console.log('get SVG');

                                _this.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.$hostname + '/admin/services/svg', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + _this.token
                                    }
                                }).then(function (response) {
                                    self.svg_list = response.data;

                                    // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
                                    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

                                    var open = indexedDB.open("MuseDatabase");

                                    open.onupgradeneeded = function () {
                                        var db = open.result;
                                        var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
                                    };

                                    open.onsuccess = function () {
                                        // Start a new transaction
                                        var db = open.result;
                                        var tx = db.transaction("MuseObjectStore", "readwrite");
                                        var store = tx.objectStore("MuseObjectStore");

                                        // Add some data
                                        store.put({ id: self.$storeVersion, object: self.svg_list });

                                        // Close the db when the transaction is done
                                        tx.oncomplete = function () {
                                            db.close();
                                        };
                                    };

                                    open.onerror = function (error) {
                                        console.log(error);
                                    };

                                    self.waiting = false;
                                }).catch(function (error) {

                                    var notification = {
                                        template: '<span><b>\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 SVG \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        save: function save() {
            var _this2 = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var i = 0; i < self.template.texts.length; i++) {

                        var activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[i].offsetLeft + _this2.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[i].offsetTop + _this2.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[i] = activeText;
                    }

                    for (var _i2 = 0; _i2 < self.template.objects.length; _i2++) {

                        var activeObj = template.objects[_i2];

                        var _centerX = _this2.$refs.draggableContainer2[_i2].offsetLeft + _this2.$refs.draggableContainer2[_i2].clientWidth / 2;
                        var _centerY = _this2.$refs.draggableContainer2[_i2].offsetTop + _this2.$refs.draggableContainer2[_i2].clientHeight / 2;

                        activeObj.position_x = parseFloat((_centerX / 360).toFixed(4));
                        activeObj.position_y = parseFloat((_centerY / 640).toFixed(4));

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i2] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/templates/create', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    self.$router.push('/templates');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        elementDrag: function elementDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer2[this.draggable_index].offsetLeft + this.$refs.draggableContainer2[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer2[this.draggable_index].offsetTop + this.$refs.draggableContainer2[this.draggable_index].clientHeight / 2;

            this.template.objects[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.objects[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        }
    }
});

/***/ }),

/***/ "kb8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"resetspan",on:{"click":_vm.resetOffsets}},[_c('sidebar-link',{attrs:{"to":"/templates"}},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("Шаблоны")])])],1),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/memories"}},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("Memories")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/preview"}},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("Превью")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/albums"}},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("Альбомы")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/tracks"}},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("Треки")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/reports"}},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("Отчеты")])]):_vm._e(),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/calendar"}},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("Календарь")])]),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/finance"}},[_c('i',{staticClass:"nc-icon nc-money-coins"}),_vm._v(" "),_c('p',[_vm._v("Финансы")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/push-tasks"}},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("Рассылки")])]):_vm._e(),_vm._v(" "),_c('sidebar-link',{attrs:{"to":"/logs"}},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("Логи")])])],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kgzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()})},{"row":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lnxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memories_vue__ = __webpack_require__("06e1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8d572d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Memories_vue__ = __webpack_require__("gRil");
function injectStyle (ssrContext) {
  __webpack_require__("LAba")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f8d572d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Memories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8d572d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Memories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lroX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("M+AW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4f6204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("FfxF");
function injectStyle (ssrContext) {
  __webpack_require__("Xnfv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b4f6204"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4f6204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lt2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'project_id', 'locale', 'title', 'text', 'push_code', 'status', 'created_at', ''],
            data: [],
            waiting: false,
            status: localStorage.getItem('pp_status') ? localStorage.getItem('pp_status') : "",
            loading: false,
            limit: 10,
            token: localStorage.getItem('token'),
            offset: parseInt(localStorage.getItem('pp_active_offset')) || 0
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return __WEBPACK_IMPORTED_MODULE_0_moment_moment___default()(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            localStorage.setItem('pp_active_offset', "0");
            this.offset = 0;
            this.get();
        },
        add: function add() {
            this.$router.push('/push-tasks/create');
        },
        get: function get() {
            var self = this;

            self.waiting = true;

            axios.get(this.$hostname + '/admin/services/push/tasks', {
                'params': {
                    status: this.status,
                    limit: self.limit,
                    offset: self.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.data = response.data;
                self.waiting = false;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        removeTask: function removeTask(id) {
            var self = this;

            if (confirm("Подтверждение удаление задачи " + id)) {
                self.waiting = true;

                axios.post(this.$hostname + '/admin/services/push/tasks/delete', { task_id: id }, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>\u0417\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.get();
                }).catch(function (error) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('pp_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('push-tasks') < 1) {
            localStorage.setItem('pp_active_offset', "");
        }
        next();
    }
});

/***/ }),

/***/ "mx5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ndI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Vcpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e77c272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("Hz/N");
function injectStyle (ssrContext) {
  __webpack_require__("h4pk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e77c272"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e77c272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nm/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("9gRq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b01b3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("+MYI");
function injectStyle (ssrContext) {
  __webpack_require__("zLY3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b01b3f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b01b3f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oMSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'user_id', 'type', 'locale', 'version', 'file', 'created_at'],
            data: [],
            type: "",
            types: localStorage.getItem('l_types') ? JSON.parse(localStorage.getItem('l_types')) : [],
            loading: false
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY HH:mm');
            } else {
                return '';
            }
        }
    },
    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        openLink: function openLink(link) {
            console.log(link);
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            this.loading = true;

            axios.get(this.$hostname + '/admin/services/logs/', {
                'params': {
                    type: this.type
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data.logs;
                if (self.type === "") {
                    self.types = response.data.types;
                    localStorage.setItem('l_types', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.types));
                }
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        next();
    }
});

/***/ }),

/***/ "okzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Push_vue__ = __webpack_require__("lt2r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348281d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Push_vue__ = __webpack_require__("SmHg");
function injectStyle (ssrContext) {
  __webpack_require__("L5W5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-348281d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Push_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348281d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Push_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pEA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            lock_waiting: false,
            interval: null,
            is_playing: false,
            show_svg_modal: false,
            is_object_changing: false,
            video: null,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            active_object_category: 'arrows',
            template: {
                status: 0,
                name: null,
                type: null,
                sort: 1,
                videos: null,
                duration: null,
                v: "",
                audio: null,
                audio_full: null,
                audio_size: null,
                song: null,
                song_insta: "",
                song_tiktok: "",
                push_type: 0,
                release_date: null,
                release_date_history: null,
                release_time: '12:00',
                is_premium: 0,
                is_trendy: 0,
                is_trending_music: 0,
                is_copyrighted: 0,
                is_new: 0,
                parts: [],
                texts: [],
                objects: []
            },
            categories: [],
            client_parts: [],
            is_text_active: false,
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                animation_type: 0,
                animation_duration: 0,
                shadow_blur: 0,
                shadow_alpha: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000'
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0
            },
            fonts: [{
                params: "'SF Pro', sans-serif;",
                code: "SF Pro",
                name: "SF Pro"
            }, {
                params: "'Amsterdam Four', sans-serif;",
                code: "Amsterdam Four",
                name: "Amsterdam Four"
            }, {
                params: "'Bodoni 72', sans-serif;",
                code: "Bodoni 72",
                name: "Bodoni 72"
            }, {
                params: "'Courier New', sans-serif;",
                code: "Courier New",
                name: "Courier New"
            }, {
                params: "'Didot', sans-serif;",
                code: "Didot",
                name: "Didot"
            }, {
                params: "'Menlo', sans-serif;",
                code: "Menlo",
                name: "Menlo"
            }, {
                params: "'Optima', sans-serif;",
                code: "Optima",
                name: "Optima"
            }, {
                params: "'Copperplate Gothic Light', sans-serif;",
                code: "Copperplate Gothic Light",
                name: "Copperplate"
            }, {
                params: "'Avenir', sans-serif;",
                code: "Avenir",
                name: "Avenir"
            }, {
                params: "'AmaticSC-Bold', sans-serif;",
                code: "AmaticSC-Bold",
                name: "Amatic SC"
            }, {
                params: "'Zapfino', sans-serif;",
                code: "Zapfino",
                name: "Zapfino"
            }, {
                params: "'BebasNeue-Regular', sans-serif;",
                code: "BebasNeue-Regular",
                name: "Bebas Neue"
            }, {
                params: "'Noteworthy', sans-serif;",
                code: "Noteworthy",
                name: "Noteworthy"
            }, {
                params: "'DancingScript-Bold', sans-serif;",
                code: "DancingScript-Bold",
                name: "Dancing Script"
            }, {
                params: "'Chilanka-Regular', sans-serif;",
                code: "Chilanka-Regular",
                name: "Chilanka"
            }, {
                params: "'Intro', sans-serif;",
                code: "Intro",
                name: "Intro"
            }, {
                params: "'Futura', sans-serif;",
                code: "Futura",
                name: "Futura"
            }, {
                params: "'JosefinSans-Bold', sans-serif;",
                code: "JosefinSans-Bold",
                name: "Josefin Sans"
            }, {
                params: "'Kalam-Bold', sans-serif;",
                code: "Kalam-Bold",
                name: "Kalam"
            }, {
                params: "'Lato-Regular', sans-serif;",
                code: "Lato-Regular",
                name: "Lato"
            }, {
                params: "'Lobster-Regular', sans-serif;",
                code: "Lobster-Regular",
                name: "Lobster"
            }, {
                params: "'Raleway-Bold', sans-serif;",
                code: "Raleway-Bold",
                name: "Raleway"
            }, {
                params: "'Bentoga', sans-serif;",
                code: "Bentoga-Thin",
                name: "Bentoga"
            }, {
                params: "'Brusher', sans-serif;",
                code: "Brusher",
                name: "Brusher"
            }, {
                params: "'Calistoga', sans-serif;",
                code: "Calistoga-Regular",
                name: "Calistoga"
            }, {
                params: "'Fondamento', sans-serif;",
                code: "Fondamento-Regular",
                name: "Fondamento"
            }, {
                params: "'Savoye LET', sans-serif;",
                code: "Savoye LET",
                name: "Savoye LET"
            }, {
                params: "'Homemade Apple', sans-serif;",
                code: "HomemadeApple-Regular",
                name: "Homemade Apple"
            }, {
                params: "'Luna', sans-serif;",
                code: "Luna",
                name: "Luna"
            }, {
                params: "'NewYork', sans-serif;",
                code: "NewYork",
                name: "NewYork"
            }, {
                params: "'Pathway Gothic', sans-serif;",
                code: "PathwayGothicOne-Regular",
                name: "Pathway Gothic"
            }, {
                params: "'Quattrocento', sans-serif;",
                code: "Quattrocento-Bold",
                name: "Quattrocento"
            }, {
                params: "'Syne', sans-serif;",
                code: "Syne-Bold",
                name: "Syne"
            }, {
                params: "'Thesignature', sans-serif;",
                code: "Thesignature",
                name: "Thesignature"
            }, {
                params: "'Tuesday Night', sans-serif;",
                code: "TuesdayNight-Regular",
                name: "Tuesday Night"
            }, {
                params: "'Yellowtail', sans-serif;",
                code: "Yellowtail-Regular",
                name: "Yellowtail"
            }, {
                params: "'Aegean', sans-serif;",
                code: "Aegean",
                name: "Aegean"
            }, {
                params: "'ALTA', sans-serif;",
                code: "Alta_regular",
                name: "ALTA"
            }, {
                params: "'Baskerville', sans-serif;",
                code: "Baskerville",
                name: "Baskerville"
            }, {
                params: "'Belleza', sans-serif;",
                code: "Belleza",
                name: "Belleza"
            }, {
                params: "'Black Mango', sans-serif;",
                code: "Black Mango",
                name: "Black Mango"
            }, {
                params: "'Catchy Mager', sans-serif;",
                code: "Catchy Mager",
                name: "Catchy Mager"
            }, {
                params: "'Hatton', sans-serif;",
                code: "Hatton",
                name: "Hatton"
            }, {
                params: "'HUOVA', sans-serif;",
                code: "HUOVA",
                name: "HUOVA"
            }, {
                params: "'Kudryashev', sans-serif;",
                code: "Kudryashev",
                name: "Kudryashev"
            }, {
                params: "'Laguna', sans-serif;",
                code: "Laguna",
                name: "Laguna"
            }, {
                params: "'Liana', sans-serif;",
                code: "Liana",
                name: "Liana"
            }, {
                params: "'Lovelace', sans-serif;",
                code: "Lovelace",
                name: "Lovelace"
            }, {
                params: "'Lovelo', sans-serif;",
                code: "Lovelo",
                name: "Lovelo"
            }, {
                params: "'Mak', sans-serif;",
                code: "Mak",
                name: "Mak"
            }, {
                params: "'Maragsa', sans-serif;",
                code: "Maragsa",
                name: "Maragsa"
            }, {
                params: "'Tan Pearl', sans-serif;",
                code: "Tan Pearl",
                name: "Tan Pearl"
            }, {
                params: "'Tenor', sans-serif;",
                code: "Tenor",
                name: "Tenor"
            }, {
                params: "'The Seasons', sans-serif;",
                code: "The Seasons",
                name: "The Seasons"
            }, {
                params: "'Allura', sans-serif;",
                code: "Allura",
                name: "Allura"
            }, {
                params: "'Alyssum', sans-serif;",
                code: "Alyssum",
                name: "Alyssum"
            }, {
                params: "'Bangers', sans-serif;",
                code: "Bangers",
                name: "Bangers"
            }, {
                params: "'Boulder', sans-serif;",
                code: "Boulder",
                name: "Boulder"
            }, {
                params: "'Carlson', sans-serif;",
                code: "Carlson",
                name: "Carlson"
            }, {
                params: "'Hello January', sans-serif;",
                code: "Hello January",
                name: "Hello January"
            }, {
                params: "'Hit and Run', sans-serif;",
                code: "Hit and Run",
                name: "Hit and Run"
            }, {
                params: "'Horta', sans-serif;",
                code: "Horta",
                name: "Horta"
            }, {
                params: "'Knewave', sans-serif;",
                code: "Knewave",
                name: "Knewave"
            }, {
                params: "'Lovelies', sans-serif;",
                code: "Lovelies",
                name: "Lovelies"
            }, {
                params: "'Monoton', sans-serif;",
                code: "Monoton",
                name: "Monoton"
            }, {
                params: "'Party Confetti', sans-serif;",
                code: "Party Confetti",
                name: "Party Confetti"
            }, {
                params: "'Peace', sans-serif;",
                code: "Peace",
                name: "Peace"
            }, {
                params: "'Petit Cochon', sans-serif;",
                code: "Petit Cochon",
                name: "Petit Cochon"
            }, {
                params: "'Playlist', sans-serif;",
                code: "Playlist",
                name: "Playlist"
            }, {
                params: "'Pushkin', sans-serif;",
                code: "Pushkin",
                name: "Pushkin"
            }, {
                params: "'Sarina', sans-serif;",
                code: "Sarina",
                name: "Sarina"
            }, {
                params: "'Shrikhand', sans-serif;",
                code: "Shrikhand",
                name: "Shrikhand"
            }, {
                params: "'Studly', sans-serif;",
                code: "Studly",
                name: "Studly"
            }, {
                params: "'The Youngest', sans-serif;",
                code: "The Youngest",
                name: "The Youngest"
            }, {
                params: "'Amsterdam One', sans-serif;",
                code: "Amsterdam One",
                name: "Amsterdam One"
            }, {
                params: "'Brittany', sans-serif;",
                code: "Brittany",
                name: "Brittany"
            }, {
                params: "'Daydream', sans-serif;",
                code: "Daydream",
                name: "Daydream"
            }, {
                params: "'Inters', sans-serif;",
                code: "Inters",
                name: "Inters"
            }, {
                params: "'Kavivanar', sans-serif;",
                code: "Kavivanar",
                name: "Kavivanar"
            }, {
                params: "'Mixa', sans-serif;",
                code: "Mixa",
                name: "Mixa"
            }, {
                params: "'Sisterhood', sans-serif;",
                code: "Sisterhood",
                name: "Sisterhood"
            }, {
                params: "'Virtual', sans-serif;",
                code: "Virtual",
                name: "Virtual"
            }, {
                params: "'Anton', sans-serif;",
                code: "Anton",
                name: "Anton"
            }, {
                params: "'Blue-Ocean', sans-serif;",
                code: "Blue Ocean",
                name: "Blue Ocean"
            }, {
                params: "'Cormorant', sans-serif;",
                code: "Cormorant",
                name: "Cormorant"
            }, {
                params: "'Culture', sans-serif;",
                code: "Culture",
                name: "Culture"
            }, {
                params: "'Keep-on-Truckin', sans-serif;",
                code: "Keep on Truckin",
                name: "Keep on Truckin"
            }, {
                params: "'Kingthings', sans-serif;",
                code: "Kingthings",
                name: "Kingthings"
            }, {
                params: "'Maharlika', sans-serif;",
                code: "Maharlika",
                name: "Maharlika"
            }, {
                params: "'Montserrat', sans-serif;",
                code: "Montserrat",
                name: "Montserrat"
            }, {
                params: "'Nectarine', sans-serif;",
                code: "Nectarine",
                name: "Nectarine"
            }, {
                params: "'Sandy', sans-serif;",
                code: "Sandy",
                name: "Sandy"
            }, {
                params: "'Tan-Paradiso', sans-serif;",
                code: "Tan-Paradiso",
                name: "Tan-Paradiso"
            }, {
                params: "'Well-Cake', sans-serif;",
                code: "Well-Cake",
                name: "Well-Cake"
            }, {
                params: "'Agrandir', sans-serif;",
                code: "Agrandir",
                name: "Agrandir"
            }, {
                params: "'BlackGold', sans-serif;",
                code: "BlackGold",
                name: "BlackGold"
            }, {
                params: "'Bright', sans-serif;",
                code: "Bright",
                name: "Bright"
            }, {
                params: "'Brown Sugar', sans-serif;",
                code: "Brown Sugar",
                name: "Brown Sugar"
            }, {
                params: "'Garet', sans-serif;",
                code: "Garet",
                name: "Garet"
            }, {
                params: "'Harmony', sans-serif;",
                code: "Harmony",
                name: "Harmony"
            }, {
                params: "'Migra', sans-serif;",
                code: "Migra",
                name: "Migra"
            }, {
                params: "'Migra Italic', sans-serif;",
                code: "Migra Italic",
                name: "Migra Italic"
            }, {
                params: "'Noto Serif Display', sans-serif;",
                code: "Noto Serif Display",
                name: "Noto Serif Display"
            }, {
                params: "'Pinyon Script', sans-serif;",
                code: "Pinyon Script",
                name: "Pinyon Script"
            }, {
                params: "'Sloop Script', sans-serif;",
                code: "Sloop Script",
                name: "Sloop Script"
            }, {
                params: "'Redkits', sans-serif;",
                code: "Redkits",
                name: "Redkits"
            }, {
                params: "'Sceageus', sans-serif;",
                code: "Sceageus",
                name: "Sceageus"
            }, {
                params: "'Tan Nimbus', sans-serif;",
                code: "Tan Nimbus",
                name: "Tan Nimbus"
            }, {
                params: "'Kenao', sans-serif;",
                code: "Kenao",
                name: "Kenao"
            }],
            colors: ["#FFFFFF", "#000000", "#F9F7F4", "#FAF5ED", "#F2E8DD", "#F4E4DD", "#D9BEBD", "#C5AEB6", "#E3C2D2", "#F1E0EF", "#D5C9E9", "#C8ACE0", "#E06E97", "#E64F3C", "#AB613E", "#B97959", "#D99056", "#E8BF88", "#EDD8AB", "#FAE389", "#F5C154", "#B78C3A", "#585B3B", "#7B7C41", "#BBB595", "#DFE7DA", "#C0DED3", "#B4C5C9", "#C9D9F0", "#4E63EC", "#4F5E8D", "#725B6E", "#F0F0F0", "#D9D9D9", "#616161", "#3C3C3C"],
            effect_types: [{
                id: 0,
                name: "-"
            }, {
                id: 1,
                name: "Zoom in"
            }, {
                id: 2,
                name: "Zoom out"
            }],
            text_aligns: [{
                name: "center"
            }, {
                name: "start"
            }, {
                name: "end"
            }],
            animation_types: [{
                id: 0,
                name: "Без анимации"
            }, {
                id: 1,
                name: "Fade"
            }, {
                id: 4,
                name: "Scale"
            }, {
                id: 6,
                name: "Reveal ↓"
            }, {
                id: 7,
                name: "Reveal ↑"
            }, {
                id: 8,
                name: "Reveal →"
            }, {
                id: 9,
                name: "Reveal ←"
            }, {
                id: 10,
                name: "Float ↓"
            }, {
                id: 11,
                name: "Float ↑"
            }, {
                id: 12,
                name: "Float →"
            }, {
                id: 13,
                name: "Float ←"
            }, {
                id: 14,
                name: "Typewriter"
            }],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: []
        };
    },

    watch: {
        is_playing: function is_playing(val) {
            if (val) {
                this.startInterval();
            } else {
                clearInterval(this.interval);
            }
        }
    },
    created: function created() {

        var self = this;

        self.waiting = true;

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$hostname + '/admin/categories/', {
            'params': {},
            'headers': {
                'Authorization': 'Bearer ' + self.token
            }
        }).then(function (response) {
            self.waiting = false;
            self.categories = response.data;

            // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
            var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            var open = indexedDB.open("MuseDatabase");

            open.onupgradeneeded = function () {
                var db = open.result;
                var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
            };

            open.onsuccess = function () {
                // Start a new transaction
                var db = open.result;
                var tx = db.transaction("MuseObjectStore", "readwrite");
                var store = tx.objectStore("MuseObjectStore");
                var data = store.get(self.$storeVersion);

                data.onsuccess = function () {
                    console.log(data.result);
                    if (!data.result) {
                        self.getSVG();
                    } else {
                        self.svg_list = data.result.object;
                    }
                };

                // Close the db when the transaction is done
                tx.oncomplete = function () {
                    db.close();
                };
            };

            open.onerror = function (error) {
                console.log(error);
            };
        }).catch(function (error) {
            self.waiting = false;
            console.log(error);
        });
    },
    computed: {
        sumParts: function sumParts() {
            var sum = 0;
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.client_parts, function (p) {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            });

            return sum.toFixed(2);
        },
        sortedFonts: function sortedFonts() {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(this.fonts, function (f) {
                return f.name;
            });
        }
    },
    methods: {
        text_html: function text_html(index) {

            var textModel = this.template.texts[index];

            var text = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.fonts, function (f) {
                return f.name === textModel.font_name;
            });

            var line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            var alpha = textModel.alpha;

            var direction = '';
            if (textModel.direction == 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' + '  text-orientation: upright;\n';
            }

            var offset = 4 / 88 * textModel.font_size;
            var blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            var shadow = 'text-shadow: ' + offset + 'px ' + offset + 'px ' + blur + 'px ' + textModel.shadow_color + this.convertAlphaToHex(textModel.shadow_alpha) + ';';

            return '<span style="color: ' + textModel.text_color + '; ' + 'background-color: ' + textModel.background_color + '; ' + 'font-size: ' + textModel.font_size + 'px; ' + 'letter-spacing: ' + textModel.letter_spacing + 'px; ' + 'opacity: ' + alpha + '; ' + 'line-height: ' + line_height + 'px; ' + 'transform: rotate( ' + textModel.angle + 'deg); ' + 'display: block;' + 'border: 1px solid white;' + 'padding: 5px;' + direction + shadow + 'text-align: ' + textModel.text_align + '; ' + 'z-index: ' + textModel.z_index + '; ' + 'font-family:' + text.params + ';">' + textModel.text + '</span>';
        },
        object_html: function object_html(index) {
            var objectModel = this.template.objects[index];

            if (!objectModel.source) {
                return "";
            }

            var source = objectModel.source;

            var width = 100;
            var height = 100;
            var w = source.match(/width="\d{1,5}"/);
            var h = source.match(/height="\d{1,5}"/);
            if (w && h) {
                width = w[0].split('"')[1];
                height = h[0].split('"')[1];
            }

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            source = source.replace(/width="\d{1,4}"/, 'width="' + width + '"');
            source = source.replace(/height="\d{1,4}"/, 'height="' + height + '"');
            source = source.replace(/fill="black"/g, 'fill="' + objectModel.color + '"');
            source = source.replace(/stroke="black"/g, 'stroke="' + objectModel.color + '"');

            var style = ' style="opacity: ' + objectModel.alpha + '; border: 1px solid white; padding: 0px; transform: rotate(' + objectModel.angle + 'deg); z-index: ' + objectModel.z_index + '"';

            source = this.insertAt(source, style, 5);

            return source;
        },

        isVideo: function isVideo(url) {
            return url.indexOf('.mp4') > -1;
        },
        insertAt: function insertAt(str, sub, pos) {
            return '' + str.slice(0, pos) + sub + str.slice(pos);
        },
        formatDuration: function formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.');
        },
        formatSpeed: function formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.');
        },
        formatVideoDuration: function formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.');
        },
        addText: function addText() {
            var copy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            if (copy !== false) {
                var copiedText = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                var positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(positions)));

                setTimeout(function () {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';
            }
        },
        addObject: function addObject(object) {
            var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var self = this;

            // if copied
            if (copy !== false) {
                var copiedObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.object_positions[self.active_object])));

                setTimeout(function () {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }, 100);
            } else {

                if (self.is_object_changing) {
                    var obj = self.template.objects[self.active_object];
                    obj.id = object.id;
                    obj.source = object.source;
                    obj.category = object.category;
                } else {
                    var newObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_object));
                    newObj.id = object.id;
                    newObj.source = object.source;
                    newObj.category = object.category;
                    self.template.objects.push(newObj);
                    self.object_positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }

                self.is_object_changing = false;
                self.show_svg_modal = false;
            }

            self.active_object_category = 'arrows';
        },
        changeObject: function changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        convertAlphaToHex: function convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText: function selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject: function selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory: function selectObjectCategory(category) {
            this.active_object_category = category;
        },
        removeText: function removeText(index) {
            var self = this;

            if (self.template.texts.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text';

                self.template.texts = self.template.texts.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        removeObject: function removeObject(index) {
            var self = this;

            if (self.template.objects.length < 2) {
                var notification = {
                    template: '<span><b>\u0414\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441 "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430"</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'warning'
                });

                return;
            }

            if (confirm("Подтверждение удаление объекта")) {
                self.active_object = 0;
                self.active_type = 'object';

                self.template.objects = self.template.objects.filter(function (t, i) {
                    return i !== index;
                });
            }
        },
        toggleText: function toggleText() {
            var self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_text)));
                self.positions.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.default_positions)));

                setTimeout(function () {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                    self.video = self.$refs.videoContainer;

                    self.video.addEventListener("playing", function () {
                        console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });
                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground: function toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },

        setTextPosition: function setTextPosition(x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function setObjectPosition(x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                var centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                var centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeEffectType: function changeEffectType(index, type) {

            if (type === 0) {
                return;
            }

            var from = 1;
            var to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            };
        },
        changeEffectPosition: function changeEffectPosition(event, index) {
            var offsetX = void 0;
            var offsetY = void 0;

            if (event.target.className !== 'effect-preview') {
                var parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;
                } else {}

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function setColor(color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function setObjColor(color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount: function changeVideoCount(value) {
            var self = this;
            var oldParts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            var newParts = [];
            for (var i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    effect_values: { x: 0.5, y: 0.5 }
                });
            }

            for (var _i = 0; _i < oldParts.length; _i++) {
                for (var j = 0; j < newParts.length; j++) {
                    if (_i === j) {
                        newParts[j] = oldParts[_i];
                    }
                }
            }

            this.client_parts = newParts;
        },

        showPreview: function showPreview() {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function checkElementsVisibility(currentTime) {
            var self = this;

            var elements = [self.template.texts, self.template.objects];
            for (var o = 0; o < elements.length; o++) {

                var element = elements[o];
                for (var i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function startInterval() {
            var self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
                if (self.template.duration && self.video.currentTime >= self.template.duration) {
                    self.video.load();
                }
            }, 30);
        },
        goBack: function goBack() {
            window.history.back();
        },
        showSVGModal: function showSVGModal() {
            this.show_svg_modal = true;
        },
        closeSVGModal: function closeSVGModal(event) {
            if (event && (event.srcElement.className === 'modal-wrapper' || event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'arrows';
            }
        },
        getSVG: function getSVG() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var self;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = _this;


                                console.log('get SVG');

                                _this.waiting = true;

                                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.$hostname + '/admin/services/svg', {
                                    'headers': {
                                        'Authorization': 'Bearer ' + _this.token
                                    }
                                }).then(function (response) {
                                    self.svg_list = response.data;

                                    // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
                                    var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

                                    var open = indexedDB.open("MuseDatabase");

                                    open.onupgradeneeded = function () {
                                        var db = open.result;
                                        var store = db.createObjectStore("MuseObjectStore", { keyPath: "id" });
                                    };

                                    open.onsuccess = function () {
                                        // Start a new transaction
                                        var db = open.result;
                                        var tx = db.transaction("MuseObjectStore", "readwrite");
                                        var store = tx.objectStore("MuseObjectStore");

                                        // Add some data
                                        store.put({ id: self.$storeVersion, object: self.svg_list });

                                        // Close the db when the transaction is done
                                        tx.oncomplete = function () {
                                            db.close();
                                        };
                                    };

                                    open.onerror = function (error) {
                                        console.log(error);
                                    };

                                    self.waiting = false;
                                }).catch(function (error) {

                                    var notification = {
                                        template: '<span><b>\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0438 SVG \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432</b></span>'
                                    };

                                    self.$notifications.notify({
                                        component: notification,
                                        icon: 'nc-icon nc-simple-remove',
                                        horizontalAlign: 'right',
                                        verticalAlign: 'top',
                                        type: 'danger'
                                    });

                                    self.waiting = false;
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        save: function save() {
            var _this2 = this;

            var self = this;

            var template = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.template));
            template.parts = self.client_parts;

            for (var i = 0; i < template.parts.length; i++) {
                if (template.parts[i].duration === null || template.parts[i].speed === null) {
                    var notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_insta) {
                var regex = /(\d{14,22})/gi;
                var match = regex.exec(template.song_insta);

                var reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    var _notification = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 Reels Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (template.song_tiktok) {
                var parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    var _notification2 = {
                        template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 TikTok Audio</b></span>'
                    };

                    self.$notifications.notify({
                        component: _notification2,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    return false;
                }
            }

            if (Math.abs(self.sumParts - template.duration) > 0.05) {

                var _notification3 = {
                    template: '<span><b>\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u0438\u0434\u0435\u043E</b></span>'
                };

                self.$notifications.notify({
                    component: _notification3,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                return false;
            }

            if (this.video) {
                this.video.load();
            }

            self.waiting = true;

            setTimeout(function () {

                if (_this2.is_text_active) {

                    for (var _i2 = 0; _i2 < self.template.texts.length; _i2++) {

                        var activeText = template.texts[_i2];

                        if (activeText.position_x !== 0.5) {
                            var centerX = _this2.$refs.draggableContainer[_i2].offsetLeft + _this2.$refs.draggableContainer[_i2].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            var centerY = _this2.$refs.draggableContainer[_i2].offsetTop + _this2.$refs.draggableContainer[_i2].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }

                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[_i2] = activeText;
                    }

                    for (var _i3 = 0; _i3 < self.template.objects.length; _i3++) {

                        var activeObj = template.objects[_i3];

                        var _centerX = _this2.$refs.draggableContainer2[_i3].offsetLeft + _this2.$refs.draggableContainer2[_i3].clientWidth / 2;
                        var _centerY = _this2.$refs.draggableContainer2[_i3].offsetTop + _this2.$refs.draggableContainer2[_i3].clientHeight / 2;

                        activeObj.position_x = parseFloat((_centerX / 360).toFixed(4));
                        activeObj.position_y = parseFloat((_centerY / 640).toFixed(4));

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[_i3] = activeObj;
                    }
                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this2.$hostname + '/admin/created/create', template, {
                    'headers': {
                        'Authorization': 'Bearer ' + _this2.token
                    }
                }).then(function (response) {
                    var notification = {
                        template: '<span><b>\u0428\u0430\u0431\u043B\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    self.waiting = false;

                    self.$router.push('/memories');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });

                    self.waiting = false;
                });
            }, 200);
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        },
        dragMouseDown: function dragMouseDown(event) {
            event.preventDefault();

            var path = event.composedPath ? event.composedPath() : event.path;
            var id = null;
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(path, function (p) {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            });

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX;
                this.object_positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.objectDrag;
                document.onmouseup = this.closeDragObject;
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX;
                this.positions[this.draggable_index].clientY = event.clientY;

                document.onmousemove = this.textDrag;
                document.onmouseup = this.closeDragText;
            }
        },
        elementDrag: function elementDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';
        },
        textDrag: function textDrag(event) {
            event.preventDefault();

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX;
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY;
            this.positions[this.draggable_index].clientX = event.clientX;
            this.positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer[this.draggable_index].style.top = this.$refs.draggableContainer[this.draggable_index].offsetTop - this.positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer[this.draggable_index].style.left = this.$refs.draggableContainer[this.draggable_index].offsetLeft - this.positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText: function closeDragText() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        },

        objectDrag: function objectDrag(event) {
            event.preventDefault();

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX;
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY;
            this.object_positions[this.draggable_index].clientX = event.clientX;
            this.object_positions[this.draggable_index].clientY = event.clientY;

            this.$refs.draggableContainer2[this.draggable_index].style.top = this.$refs.draggableContainer2[this.draggable_index].offsetTop - this.object_positions[this.draggable_index].movementY + 'px';

            this.$refs.draggableContainer2[this.draggable_index].style.left = this.$refs.draggableContainer2[this.draggable_index].offsetLeft - this.object_positions[this.draggable_index].movementX + 'px';

            var centerX = this.$refs.draggableContainer2[this.draggable_index].offsetLeft + this.$refs.draggableContainer2[this.draggable_index].clientWidth / 2;
            var centerY = this.$refs.draggableContainer2[this.draggable_index].offsetTop + this.$refs.draggableContainer2[this.draggable_index].clientHeight / 2;

            this.template.objects[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.objects[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragObject: function closeDragObject() {
            document.onmouseup = null;
            document.onmousemove = null;

            this.draggable_index = null;

            return false;
        }
    }
});

/***/ }),

/***/ "pYwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Название шаблона","placeholder":""},model:{value:(_vm.template.name),callback:function ($$v) {_vm.$set(_vm.template, "name", $$v)},expression:"template.name"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип шаблона")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.type),expression:"template.type"}],staticClass:"form-control",attrs:{"id":"type-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1. По дате: прошлая неделя")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2. По дате: прошлый месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3. По дате: текущий месяц")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4. По дате: прошлый год")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5. По дате: текущий год")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6. По дате: прошлые выходные")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("7. По дате: будние дни на прошлой неделе")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("8. По дате: Лето")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("9. По дате: Осень")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10. По дате: Зима")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11. По дате: Весна")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12. По дате: Лето прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13. По дате: Осень прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14. По дате: Зима прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15. По дате: Весна прошлого года")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16. По местоположению: Путешествие")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17. По местоположению: Дом")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18. One day of my life")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19. Recently")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20. Day of my life with date")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21. Spring Camera Roll")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22. Spring  Recap")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23. По дате: за последние 6 месяцев")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.status),expression:"template.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Опубликовано")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Ожидает")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Минимальная версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.v),expression:"template.v"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "v", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Все версии")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"2.1"}},[_vm._v("2.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.2"}},[_vm._v("2.2")]),_vm._v(" "),_c('option',{attrs:{"value":"2.7"}},[_vm._v("2.7")]),_vm._v(" "),_c('option',{attrs:{"value":"2.8"}},[_vm._v("2.8")]),_vm._v(" "),_c('option',{attrs:{"value":"2.9"}},[_vm._v("2.9")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.1"}},[_vm._v("3.1")]),_vm._v(" "),_c('option',{attrs:{"value":"3.2"}},[_vm._v("3.2")]),_vm._v(" "),_c('option',{attrs:{"value":"3.3"}},[_vm._v("3.3")]),_vm._v(" "),_c('option',{attrs:{"value":"3.4"}},[_vm._v("3.4")]),_vm._v(" "),_c('option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('option',{attrs:{"value":"3.6"}},[_vm._v("3.6")]),_vm._v(" "),_c('option',{attrs:{"value":"3.7"}},[_vm._v("3.7")]),_vm._v(" "),_c('option',{attrs:{"value":"3.8"}},[_vm._v("3.8")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("4.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.1"}},[_vm._v("4.1")]),_vm._v(" "),_c('option',{attrs:{"value":"4.2"}},[_vm._v("4.2")]),_vm._v(" "),_c('option',{attrs:{"value":"4.3"}},[_vm._v("4.3")]),_vm._v(" "),_c('option',{attrs:{"value":"4.4"}},[_vm._v("4.4")]),_vm._v(" "),_c('option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('option',{attrs:{"value":"4.6"}},[_vm._v("4.6")]),_vm._v(" "),_c('option',{attrs:{"value":"5.0"}},[_vm._v("5.0")]),_vm._v(" "),_c('option',{attrs:{"value":"5.1"}},[_vm._v("5.1")]),_vm._v(" "),_c('option',{attrs:{"value":"5.2"}},[_vm._v("5.2")]),_vm._v(" "),_c('option',{attrs:{"value":"5.3"}},[_vm._v("5.3")]),_vm._v(" "),_c('option',{attrs:{"value":"5.4"}},[_vm._v("5.4")]),_vm._v(" "),_c('option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('option',{attrs:{"value":"5.6"}},[_vm._v("5.6")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип публикации")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.push_type),expression:"template.push_type"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template, "push_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Стандартный")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Доступен через час + пуш с превью")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.template.sort),callback:function ($$v) {_vm.$set(_vm.template, "sort", $$v)},expression:"template.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Название трека","placeholder":""},model:{value:(_vm.template.song),callback:function ($$v) {_vm.$set(_vm.template, "song", $$v)},expression:"template.song"}}),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на Reels audio","placeholder":""},model:{value:(_vm.template.song_insta),callback:function ($$v) {_vm.$set(_vm.template, "song_insta", $$v)},expression:"template.song_insta"}}):_vm._e(),_vm._v(" "),(_vm.template.is_copyrighted)?_c('fg-input',{attrs:{"type":"text","label":"Ссылка на TikTok audio","placeholder":""},model:{value:(_vm.template.song_tiktok),callback:function ($$v) {_vm.$set(_vm.template, "song_tiktok", $$v)},expression:"template.song_tiktok"}}):_vm._e(),_vm._v(" "),_c('fg-input',{attrs:{"type":"date","label":"Дата публикации (формат ДД.ММ.ГГГГ)","placeholder":""},model:{value:(_vm.template.release_date),callback:function ($$v) {_vm.$set(_vm.template, "release_date", $$v)},expression:"template.release_date"}}),_vm._v(" "),(_vm.template.release_date)?_c('fg-input',{attrs:{"type":"time","label":"Время публикации (формат HH:MM)","placeholder":""},model:{value:(_vm.template.release_time),callback:function ($$v) {_vm.$set(_vm.template, "release_time", $$v)},expression:"template.release_time"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 checkbox-block"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_premium),expression:"template.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_premium)?_vm._i(_vm.template.is_premium,null)>-1:(_vm.template.is_premium)},on:{"change":function($event){var $$a=_vm.template.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"new-control"}},[_vm._v("Новое")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_new),expression:"template.is_new"}],staticClass:"form-check-inline",attrs:{"id":"new-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_new)?_vm._i(_vm.template.is_new,null)>-1:(_vm.template.is_new)},on:{"change":function($event){var $$a=_vm.template.is_new,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_new", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_new", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_new", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"copyrighted-control"}},[_vm._v("Copyrighted-музыка")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.is_copyrighted),expression:"template.is_copyrighted"}],staticClass:"form-check-inline",attrs:{"id":"copyrighted-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.template.is_copyrighted)?_vm._i(_vm.template.is_copyrighted,null)>-1:(_vm.template.is_copyrighted)},on:{"change":function($event){var $$a=_vm.template.is_copyrighted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.template, "is_copyrighted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.template, "is_copyrighted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.template, "is_copyrighted", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"text-control"}},[_vm._v("Наложение\n                                        текста/объекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_text_active),expression:"is_text_active"}],staticClass:"form-check-inline",attrs:{"id":"text-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.is_text_active)?_vm._i(_vm.is_text_active,null)>-1:(_vm.is_text_active)},on:{"change":[function($event){var $$a=_vm.is_text_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_text_active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_text_active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_text_active=$$c}},function($event){return _vm.toggleText()}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Видео: "),(_vm.template.preview_src_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.preview_src_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):(_vm.template.preview_src_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.preview_src_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.preview_src_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"previewFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'preview_src')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.previewFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"margin-top"},[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                        Аудио: "),(_vm.template.audio_full)?_c('span',[_c('span',{staticClass:"inline-link"},[(_vm.template.audio_size >= 1)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):(_vm.template.audio_size >= 0.5)?_c('span',{staticClass:"bg-warning"},[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]):_c('span',[_vm._v(_vm._s(_vm.template.audio_size)+"Mb")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.template.audio_full,"target":"_blank"}},[_vm._v("(ссылка)")])])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"audioFileInput",staticClass:"btn-file",attrs:{"type":"file","accept":"audio/mp3"},on:{"change":function($event){return _vm.uploadFile($event, 'audio')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.audioFileInput.click()}}},[_vm._v("\n                                            Загрузить\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.template.videos || !_vm.template.type || !_vm.template.name
                                    || !_vm.template.song || !_vm.template.audio || !_vm.template.preview_src
                                    || (_vm.template.is_copyrighted === true && (!_vm.template.song_insta && !_vm.template.song_tiktok))},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()]),_vm._v(" "),_c('card',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_text_active),expression:"is_text_active"}]},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                        Текст")]),_vm._v(" "),(_vm.is_text_active)?_c('div',{staticClass:"texts-buttons"},[_vm._l((_vm.template.texts),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_text && _vm.active_type === 'text'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectText(index)}}},[_vm._v(_vm._s(t.text)+"\n                            "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.template.objects),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : index === _vm.active_object && _vm.active_type === 'object'},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObject(index)}}},[_c('img',{staticClass:"button-preview",attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (t.id))}}),_vm._v(" "),(t.animation_type !== 0)?_c('span',{staticClass:"animated-icon"},[_vm._v("•")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.active_type === 'text' ? _vm.addText(_vm.active_text) : _vm.addObject(null, _vm.active_object)}}},[_vm._v("\n                            Копировать\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.addText()}}},[_vm._v("Добавить текст\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-text btn-fill active control-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.showSVGModal()}}},[_vm._v("Добавить объект\n                        ")])],2):_vm._e(),_vm._v(" "),(_vm.show_svg_modal)?_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeSVGModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('button',{staticClass:"btn btn-text btn-fill",class:{ 'active' : t.category === _vm.active_object_category},attrs:{"type":"button"},on:{"click":function($event){return _vm.selectObjectCategory(t.category)}}},[_vm._v("\n                                            "+_vm._s(t.category === 'styled_shapes' ? 'Style shapes' : t.category)+"\n                                        ")])})})],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",function(){return _vm._l((_vm.svg_list),function(t,index){return _c('div',_vm._l((t.files),function(c,index){return (t.category === _vm.active_object_category)?_c('div',{staticClass:"object-item",on:{"click":function($event){return _vm.addObject(c)}}},[_c('img',{attrs:{"alt":"","src":("static/objects/" + (t.category) + "/" + (c.id))}})]):_vm._e()}),0)})})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",function(){return [_c('button',{staticClass:"btn btn-info btn-fill modal-close-button",on:{"click":_vm.closeSVGModal}},[_vm._v("\n                                            Закрыть\n                                        ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'text')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Текст")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text),expression:"template.texts[active_text].text"}],staticClass:"text-area",domProps:{"value":(_vm.template.texts[_vm.active_text].text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления текста (0 - c начала)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_start),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_start", $$v)},expression:"template.texts[active_text].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].time_end),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "time_end", $$v)},expression:"template.texts[active_text].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер шрифта: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].font_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"5","max":"200","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].font_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "font_size", $$v)},expression:"template.texts[active_text].font_size"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Шрифт")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].font_name),expression:"template.texts[active_text].font_name"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "font_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortedFonts),function(f){return _c('option',{domProps:{"value":f.name}},[_vm._v(_vm._s(f.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control1"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control1","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_x == 0.5},on:{"change":function($event){return _vm.setTextPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control2"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control2","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].position_y == 0.5},on:{"change":function($event){return _vm.setTextPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот текста (градусы)","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].angle),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "angle", $$v)},expression:"template.texts[active_text].angle"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межбуквенный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].letter_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "letter_spacing", $$v)},expression:"template.texts[active_text].letter_spacing"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Межстрочный интервал","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].line_spacing),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "line_spacing", $$v)},expression:"template.texts[active_text].line_spacing"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет текста: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].text_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_color),expression:"template.texts[active_text].text_color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "text_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].text_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'color')}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет фона:\n                                        "),(_vm.template.texts[_vm.active_text].background_color === 'transparent')?_c('span',{staticClass:"param-span"},[_vm._v("Прозрачный")]):_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].background_color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].background_color),expression:"template.texts[active_text].background_color"},{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.texts[_vm.active_text].background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "background_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"background-control"}},[_vm._v("Прозрачный")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"background-control","type":"checkbox"},domProps:{"checked":_vm.template.texts[_vm.active_text].background_color === 'transparent'},on:{"change":function($event){return _vm.toggleBackground()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].background_color !== 'transparent'),expression:"template.texts[active_text].background_color !== 'transparent'"}],staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.texts[_vm.active_text].background_color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setColor(c, 'background')}}})}),0)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "alpha", $$v)},expression:"template.texts[active_text].alpha"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Направление текста")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].direction),expression:"template.texts[active_text].direction"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"normal"}},[_vm._v("normal")]),_vm._v(" "),_c('option',{attrs:{"value":"vertical"}},[_vm._v("vertical")]),_vm._v(" "),_c('option',{attrs:{"value":"round"}},[_vm._v("round")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].animation_type),expression:"template.texts[active_text].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].animation_duration)+" сек")])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.texts[_vm.active_text].animation_type !== 0),expression:"template.texts[active_text].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "animation_duration", $$v)},expression:"template.texts[active_text].animation_duration"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Выравнивание "),_c('br'),_vm._v("(если больше одной строки)")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].text_align),expression:"template.texts[active_text].text_align"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.texts[_vm.active_text], "text_align", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.text_aligns),function(ta){return _c('option',{domProps:{"value":ta.name}},[_vm._v(_vm._s(ta.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('label',{attrs:{"for":"shadow-color"}},[_vm._v("Цвет тени:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].shadow_color),expression:"template.texts[active_text].shadow_color"}],attrs:{"type":"color","id":"shadow-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].shadow_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "shadow_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Радиус размытия тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_blur))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_blur),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_blur", $$v)},expression:"template.texts[active_text].shadow_blur"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость тени: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].shadow_alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].shadow_alpha),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "shadow_alpha", $$v)},expression:"template.texts[active_text].shadow_alpha"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер обводки: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.texts[_vm.active_text].stroke_size))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"100","step":"1","label":"","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].stroke_size),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "stroke_size", $$v)},expression:"template.texts[active_text].stroke_size"}}),_vm._v(" "),_c('label',{attrs:{"for":"stroke-color"}},[_vm._v("Цвет обводки:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.texts[_vm.active_text].stroke_color),expression:"template.texts[active_text].stroke_color"}],attrs:{"type":"color","id":"stroke-color"},domProps:{"value":(_vm.template.texts[_vm.active_text].stroke_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.texts[_vm.active_text], "stroke_color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.texts[_vm.active_text].z_index),callback:function ($$v) {_vm.$set(_vm.template.texts[_vm.active_text], "z_index", $$v)},expression:"template.texts[active_text].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeText(_vm.active_text)}}},[_vm._v("Удалить текст\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),(_vm.is_text_active && _vm.active_type === 'object')?_c('div',{staticClass:"col-md-4 c-labels"},[_c('label',{staticClass:"control-label"},[_vm._v("Объект")]),_vm._v(" "),_c('img',{staticClass:"object-preview",attrs:{"alt":"","src":("static/objects/" + (_vm.template.objects[_vm.active_object].category) + "/" + (_vm.template.objects[_vm.active_object].id))},on:{"click":function($event){return _vm.changeObject()}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время появления объекта (0 - c начала)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_start),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_start", $$v)},expression:"template.objects[active_object].time_start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Время исчезновения (пустое - до конца)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].time_end),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "time_end", $$v)},expression:"template.objects[active_object].time_end"}})],1)]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Размер: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].scale))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0.03","max":"5","step":"0.005","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].scale),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "scale", $$v)},expression:"template.objects[active_object].scale"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control3"}},[_vm._v("По центру по горизонтали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control3","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_x == 0.5},on:{"change":function($event){return _vm.setObjectPosition(0.5, null)}}}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('label',{staticClass:"control-label label-checkbox mb10",attrs:{"for":"control4"}},[_vm._v("По центру по вертикали")]),_vm._v(" "),_c('input',{staticClass:"form-check-inline",attrs:{"id":"control4","type":"checkbox"},domProps:{"checked":_vm.template.objects[_vm.active_object].position_y == 0.5},on:{"change":function($event){return _vm.setObjectPosition(null, 0.5)}}})]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Поворот объекта (градусы)","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].angle),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "angle", $$v)},expression:"template.objects[active_object].angle"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].id.indexOf('nocolor') < 0),expression:"template.objects[active_object].id.indexOf('nocolor') < 0"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Цвет: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].color))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].color),expression:"template.objects[active_object].color"}],attrs:{"type":"color"},domProps:{"value":(_vm.template.objects[_vm.active_object].color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.template.objects[_vm.active_object], "color", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"color-set"},_vm._l((_vm.colors),function(c){return _c('span',{class:{ 'active' : c === _vm.template.objects[_vm.active_object].color},style:({ backgroundColor: c }),on:{"click":function($event){return _vm.setObjColor(c)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Анимация")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.template.objects[_vm.active_object].animation_type),expression:"template.objects[active_object].animation_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.template.objects[_vm.active_object], "animation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.animation_types),function(t){return _c('option',{domProps:{"value":t.id}},[_vm._v(_vm._s(t.name))])}),0)]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],staticClass:"control-label"},[_vm._v("Длительность анимации: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].animation_duration))])]),_vm._v(" "),_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.template.objects[_vm.active_object].animation_type !== 0),expression:"template.objects[active_object].animation_type !== 0"}],attrs:{"type":"range","min":"0","max":"1.5","step":"0.1","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].animation_duration),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "animation_duration", $$v)},expression:"template.objects[active_object].animation_duration"}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Видимость: "),_c('span',{staticClass:"param-span"},[_vm._v(_vm._s(_vm.template.objects[_vm.active_object].alpha))])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"range","min":"0","max":"1","step":"0.01","label":"","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].alpha),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "alpha", $$v)},expression:"template.objects[active_object].alpha"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Z-индекс","placeholder":""},model:{value:(_vm.template.objects[_vm.active_object].z_index),callback:function ($$v) {_vm.$set(_vm.template.objects[_vm.active_object], "z_index", $$v)},expression:"template.objects[active_object].z_index"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeObject(_vm.active_object)}}},[_vm._v("Удалить объект\n                                ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.template)?_c('div',{attrs:{"id":"preview-container"}},[_c('div',{attrs:{"id":"player"}},[_c('video',{ref:"videoContainer",staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"controls":"","disablepictureinpicture":"","muted":"","controlsList":"nofullscreen nodownload noremoteplayback noplaybackrate","playsinline":"","id":"video_player"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.template.preview_src_full}})]),_vm._v(" "),_vm._l((_vm.template.texts),function(tt,index){return (tt.font_size)?_c('div',{ref:"draggableContainer",refInFor:true,staticClass:"draggable-container",attrs:{"id":("" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header",domProps:{"innerHTML":_vm._s(_vm.text_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()}),_vm._v(" "),_vm._l((_vm.template.objects),function(tt,index){return (tt.scale)?_c('div',{ref:"draggableContainer2",refInFor:true,staticClass:"draggable-container",attrs:{"id":("o" + index)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(tt.is_visible === 1),expression:"tt.is_visible === 1"}],staticClass:"draggable-header nospace",domProps:{"innerHTML":_vm._s(_vm.object_html(index))},on:{"mousedown":_vm.dragMouseDown}})]):_vm._e()})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-toggle",class:{ 'active-state': _vm.template.src_full },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showPreview()}}},[_vm._v("\n                                        Показать превью\n                                    ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Параметры видео")]),_vm._v(" "),(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),(_vm.template)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Длительность, сек.","placeholder":""},on:{"input":function($event){return _vm.formatVideoDuration($event)}},model:{value:(_vm.template.duration),callback:function ($$v) {_vm.$set(_vm.template, "duration", $$v)},expression:"template.duration"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество фрагментов","placeholder":""},on:{"input":_vm.changeVideoCount},model:{value:(_vm.template.videos),callback:function ($$v) {_vm.$set(_vm.template, "videos", $$v)},expression:"template.videos"}}),_vm._v(" "),_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Фрагменты "),_c('br'),_vm._v("(длительность:\n                                    "),(Math.abs(_vm.sumParts - _vm.template.duration) > 0.05)?_c('span',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.sumParts))]):_c('span',[_vm._v(_vm._s(_vm.sumParts))]),_vm._v("):\n                                ")]),_vm._v(" "),_vm._l((_vm.client_parts),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"#" + String(index + 1) + " - длительность","placeholder":""},on:{"input":function($event){return _vm.formatDuration($event, index)}},model:{value:(_vm.client_parts[index].duration),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "duration", $$v)},expression:"client_parts[index].duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Скорость","placeholder":""},on:{"input":function($event){return _vm.formatSpeed($event, index)}},model:{value:(_vm.client_parts[index].speed),callback:function ($$v) {_vm.$set(_vm.client_parts[index], "speed", $$v)},expression:"client_parts[index].speed"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Эффект")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_parts[index].effect_type),expression:"client_parts[index].effect_type"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.client_parts[index], "effect_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeEffectType(index, _vm.client_parts[index].effect_type)}]}},_vm._l((_vm.effect_types),function(e){return _c('option',{domProps:{"value":e.id}},[_vm._v(_vm._s(e.name))])}),0)])])]),_vm._v(" "),(_vm.client_parts[index].effect_type !== 0 && _vm.client_parts[index].effect_values)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"effect-values"},[_vm._v(_vm._s(_vm.effect_types[_vm.client_parts[index].effect_type].name)+" - Параметры")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"effect-preview",on:{"click":function($event){return _vm.changeEffectPosition($event, index)}}},[_c('span',{staticClass:"effect-area",style:({'top': _vm.client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                    'left': _vm.client_parts[index].effect_values.x * 48 - 15 + 'px'})},[_c('span',{staticClass:"effect-center"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Начальное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.from),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "from", $$v)},expression:"client_parts[index].effect_values.from"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"number","step":"0.1","label":"#" + String(index + 1) + " - Конечное значение","placeholder":""},model:{value:(_vm.client_parts[index].effect_values.to),callback:function ($$v) {_vm.$set(_vm.client_parts[index].effect_values, "to", $$v)},expression:"client_parts[index].effect_values.to"}})],1)]):_vm._e()])])})],2)])]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qg9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");
var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            columns: ['period', 'my_feed', 'muse', 'wallpapers', 'imagine', 'framy', 'marketing_spend', 'summary', ''],
            data: [],
            summary: [],
            dateStart: '',
            dateEnd: '',
            type: "",
            dates_start: localStorage.getItem('r_dates_start') ? JSON.parse(localStorage.getItem('r_dates_start')) : [],
            dates_end: localStorage.getItem('r_dates_end') ? JSON.parse(localStorage.getItem('r_dates_end')) : [],
            loading: false
        };
    },

    filters: {
        toEasyDate: function toEasyDate(value) {
            if (value) {
                return moment(String(value)).format('DD.MM.YYYY');
            } else {
                return '';
            }
        },
        toMoneyFormat: function toMoneyFormat(value) {
            if (value) {
                return Intl.NumberFormat().format(value);
            } else {
                return '';
            }
        }
    },
    created: function created() {
        this.get();
    },
    methods: {
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/reports/create');
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-report',
                params: { id: id }
            });
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            var dateStart = this.dateStart === null ? '' : this.dateStart;
            var dateEnd = this.dateEnd === null ? '' : this.dateEnd;

            this.loading = true;

            axios.get(this.$hostname + '/admin/reports/', {
                'params': {
                    date_start: dateStart,
                    date_end: dateEnd
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.loading = false;
                self.data = response.data.reports;
                self.summary = response.data.sumArray;

                var reversed = _.reverse(self.data);
                if (self.dates_start.length < 1) {
                    _.map(reversed, function (d) {
                        self.dates_start.push(d.date_start);
                    });
                    localStorage.setItem('r_dates_start', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.dates_start));
                }
                if (self.dates_end.length < 1) {
                    _.map(reversed, function (d) {
                        self.dates_end.push(d.date_end);
                    });
                    localStorage.setItem('r_dates_end', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.dates_end));
                }
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        localStorage.setItem('r_dates_start', []);
        localStorage.setItem('r_dates_end', []);
        next();
    }
});

/***/ }),

/***/ "rVgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            waiting: false,
            token: localStorage.getItem('token'),
            client_release_date: null,
            client_release_time: '12:00',
            task: {
                project_id: 9,
                is_premium: "all",
                version: "all",
                token: "",
                list_key: null,
                release_date: null,
                push_payload: {
                    type: "1",
                    id: "",
                    template_id: ""
                }
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                },
                timeout: 60000
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                for (var i = 0; i < data.locales.length; i++) {
                    data.locales[i].code = data.locales[i].locale;
                }

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        create: function create() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(self.$hostname + '/admin/services/push/tasks/create', self.task, {
                'headers': {
                    'Authorization': 'Bearer ' + self.token
                },
                timeout: 60000
            }).then(function (response) {

                self.waiting = false;

                var notification = {
                    template: '<span><b>\u0417\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/push-tasks');
            }).catch(function (error) {

                self.waiting = false;

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            this.task.locales = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            this.task.release_date = this.client_release_date + ' ' + this.client_release_time + ':00';

            this.waiting = true;

            if (this.task.token) {
                self.create();
            } else {

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/push/tasks/audience', this.task, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    if (confirm("Подтвердить отправку уведомления " + response.data + " пользователям")) {

                        self.create();
                    } else {
                        self.waiting = false;
                    }
                }).catch(function (error) {

                    self.waiting = false;

                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        }
    }
});

/***/ }),

/***/ "rg7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Альбомы")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('a_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить альбом\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'image_src_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'tracks_number')?_c('span',[_vm._v("количество треков")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rkeS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'drop-down',
    props: {
        title: String,
        icon: String,
        tag: {
            type: String,
            default: 'li'
        }
    },
    data: function data() {
        return {
            isOpen: false
        };
    },

    methods: {
        toggleDropDown: function toggleDropDown() {
            this.isOpen = !this.isOpen;
            this.$emit('change', this.isOpen);
        },
        closeDropDown: function closeDropDown() {
            this.isOpen = false;
            this.$emit('change', this.isOpen);
        }
    }
});

/***/ }),

/***/ "sdGd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tmV1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tuVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("VRrk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1f0c6f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("6Egk");
function injectStyle (ssrContext) {
  __webpack_require__("Kmkn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1f0c6f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1f0c6f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tyJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Отчеты")]),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Начальная дата")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateStart),expression:"dateStart"}],staticClass:"form-control",attrs:{"id":"date-start-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateStart=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dates_start),function(d){return _c('option',{domProps:{"value":d}},[_vm._v(_vm._s(_vm._f("toEasyDate")(d)))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"is-premium-filter"}},[_vm._v("Конечная дата")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateEnd),expression:"dateEnd"}],staticClass:"form-control",attrs:{"id":"date-start-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateEnd=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dates_end),function(d){return _c('option',{domProps:{"value":d}},[_vm._v(_vm._s(_vm._f("toEasyDate")(d)))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                        Фильтровать\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                        Загрузить отчет\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'period')?_c('span',[_vm._v("Период")]):(column === 'my_feed')?_c('span',[_vm._v("My Feed, $")]):(column === 'muse')?_c('span',[_vm._v("Muse, $")]):(column === 'wallpapers')?_c('span',[_vm._v("Wallpapers, $")]):(column === 'imagine')?_c('span',[_vm._v("Imagine, $")]):(column === 'framy')?_c('span',[_vm._v("Framy, $")]):(column === 'marketing_spend')?_c('span',[_vm._v("Расходы (Маркетинг, команда), $")]):(column === 'summary')?_c('span',[_vm._v("Всего, $")]):_c('span')])})})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.data),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("toEasyDate")(item.date_start))+" - "+_vm._s(_vm._f("toEasyDate")(item.date_end)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[0])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[3])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.info[4])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.marketing_spend))+" ("+_vm._s(_vm._f("toMoneyFormat")(item.other_spend))+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(item.summary)))]),_vm._v(" "),_c('td')])}),_vm._v(" "),(_vm.summary)?_c('tr',{staticClass:"summary"},[_c('td',[(_vm.data.length > 0)?_c('span',[_vm._v(_vm._s(_vm._f("toEasyDate")(_vm.data[0].date_start))+" - "+_vm._s(_vm._f("toEasyDate")(_vm.data[_vm.data.length - 1].date_end)))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[0])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[1])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[3])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[4])))]),_vm._v(" "),_c('td',[_vm._v("0 (0)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toMoneyFormat")(_vm.summary[5])))])]):_vm._e()],2)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u6Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uT4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uzar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            data: {
                reports_src: null,
                reportsBRL_src: null,
                rates_src: null,
                revenue: 0,
                revenue_0: 0,
                revenue_1: 0,
                revenue_2: 0,
                revenue_3: 0,
                revenue_4: 0
            }
        };
    },

    created: function created() {},
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        upload: function upload() {
            var self = this;

            var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/reports/parse', data, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {
                self.waiting = false;

                var id = response.data.id;

                self.$router.push('/reports/');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {

            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/reports/file/upload', formData, {
                params: {
                    file_type: type,
                    reports: true
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.data[data.file_type] = data.url;
                self.data[data.file_type + '_full'] = data.url_full;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "v8vN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKl8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vQaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Треки")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row stats-block mt10"},[_c('span',[_vm._v("Количество альбомов: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.albums.length))])]),_vm._v(" "),_c('span',[_vm._v("Количество треков: "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.tracksCount))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Альбом")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.album),expression:"album"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.album=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('t_album', _vm.album)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.albums),function(a){return _c('option',{domProps:{"value":a.id}},[_vm._v(_vm._s(a.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('t_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить трек\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'album')?_c('span',[_vm._v("альбом")]):(column === 'artist')?_c('span',[_vm._v("артист")]):(column === 'title')?_c('span',[_vm._v("название")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'is_trendy')?_c('span',[_vm._v("популярное")]):(column === 'src_full')?_c('span',[_vm._v("трек")]):(column === 'image_src_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'duration')?_c('span',[_vm._v("длительность")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'image_src_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[(item[column])?_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')' })}):_vm._e(),_vm._v(" "),(!item[column])?_c('img',{staticClass:"device1",attrs:{"src":"/static/img/track.png"}}):_vm._e()]):(column === 'duration')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'src_full')?_c('span',[_c('audio',{attrs:{"src":item[column],"onloadstart":"this.volume=0.5","controls":"controls","controlsList":"nodownload noplaybackrate"}})]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'is_trendy')?_c('span',{staticClass:"emodji"},[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("🖤")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vqQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'image_src_full', 'tracks_number', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('a_status') ? localStorage.getItem('a_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/albums/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/albums/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-album',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('albums') < 1) {
            localStorage.setItem('a_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "wD3J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Настройки")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Версия")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1","selected":""}},[_vm._v("Production")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Dev")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('button',{staticClass:"btn btn-info btn-fill btn-filter",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.get()}}},[_vm._v("\n                                    Фильтровать\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save btn-filter",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_vm._v("\n                                    Сохранить\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Список категорий")]),_vm._v(" "),_c('draggable',{model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('transition-group',_vm._l((_vm.data),function(element){return _c('div',{key:element.id,staticClass:"category-list"},[_vm._v("\n                                                "+_vm._s(element.name)+"\n                                            ")])}),0)],1)],1)])])])])],1),_vm._v(" "),_c('div',{staticClass:"card col-xl-8 col-md-8"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-area"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.showTemplates(_vm.categoryId)}]}},_vm._l((_vm.data),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}),0)])]),_vm._v(" "),_vm._l((_vm.data),function(itm,i){return _c('div',{key:i},[(_vm.data[i].id === _vm.categoryId)?_c('div',[(_vm.data[i].templates.length > 0)?_c('p',{staticClass:"category-name"},[_vm._v(_vm._s(_vm.data[i].name))]):_vm._e(),_vm._v(" "),(_vm.data[i].templates.length > 0)?_c('div',{staticClass:"scrolling-wrapper"},[_c('draggable',{model:{value:(_vm.data[i].templates),callback:function ($$v) {_vm.$set(_vm.data[i], "templates", $$v)},expression:"data[i].templates"}},_vm._l((_vm.data[i].templates),function(itm,j){return _c('div',{staticClass:"inline-div",on:{"click":function($event){$event.preventDefault();return _vm.openVideo(_vm.data[i].templates[j].src_full)}}},[(!_vm.isVideo(_vm.data[i].templates[j].preview_src_full))?_c('div',{key:j,staticClass:"card-template",style:({ 'background-image': 'url(' + _vm.data[i].templates[j].preview_src_full + ')' })}):_vm._e(),_vm._v(" "),(_vm.isVideo(_vm.data[i].templates[j].preview_src_full))?_c('div',{staticClass:"card-template",on:{"click":function($event){$event.preventDefault();return _vm.openVideo(_vm.data[i].templates[j].src_full)}}},[_c('video',{key:_vm.getTemplateSrc(_vm.data[i].templates[j].preview_src_full),staticStyle:{"max-width":"100%","cursor":"pointer"},attrs:{"muted":"","loop":"","autoplay":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.getTemplateSrc(_vm.data[i].templates[j].preview_src_full),"type":_vm.getTemplateType()}})])]):_vm._e()])}),0)],1):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.activeVideo)?_c('div',{staticClass:"video-bg",on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),(_vm.activeVideo)?_c('div',{attrs:{"id":"player"}},[_c('video',{staticStyle:{"max-width":"100%"},attrs:{"onloadstart":"this.volume=0.1","controls":"","autoplay":"","id":"video_player"}},[_c('source',{attrs:{"src":_vm.activeVideo}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-close",class:{ 'active-state': _vm.activeVideo },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeVideo()}}},[_vm._v("\n                            Закрыть\n                        ")])]):_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"after"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wR3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("YbGq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af0b290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("GfbQ");
function injectStyle (ssrContext) {
  __webpack_require__("GRHK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1af0b290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af0b290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+N7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x//Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("kP44");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164bf410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("YEKA");
function injectStyle (ssrContext) {
  __webpack_require__("sdGd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164bf410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164bf410_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "yYsp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yiba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",function(){return [(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")]):_vm._e()]}),_vm._v(" "),_vm._t("addonLeft",function(){return [(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]}),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",function(){return [(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yyh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Логи")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Тип")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control",attrs:{"id":"type-filter","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.types),function(t){return _c('option',{domProps:{"value":t}},[_vm._v(_vm._s(t))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"})])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'user_id')?_c('span',[_vm._v("user ID")]):(column === 'locale')?_c('span',[_vm._v("locale")]):(column === 'version')?_c('span',[_vm._v("version")]):(column === 'file')?_c('span',[_vm._v("file")]):(column === 'created_at')?_c('span',[_vm._v("date")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'created_at')?_c('span',[_vm._v("\n                                            "+_vm._s(_vm._f("toEasyDate")(item[column]))+"\n                                        ")]):(column === 'file')?_c('span',[_c('a',{staticClass:"text-primary",attrs:{"target":"_blank","href":item[column]}},[_vm._v(_vm._s(item[column]))])]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zLY3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        routeName: function routeName() {
            var name = this.$route.name;

            return this.capitalizeFirstLetter(name);
        }
    },
    data: function data() {
        return {
            activeNotifications: false
        };
    },

    methods: {
        capitalizeFirstLetter: function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown: function toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown: function closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar: function toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar: function hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },

        logout: function logout() {
            localStorage.removeItem('token');

            this.$router.push('/login');
        }
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.608208cfe713ef8e76d2.js